
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

// import healthData from "../../Configurations/Healthdata.json";
import AyujaBanner from "../BannerScreens/AyujaBanner";
import FloatingSupportWidget from "./Floatingcallsupportwidget";
import DiagnosticSample from "../Logos/diagnostic_collection.png";
import DoctorVisitPickupDrop from "../Logos/medicine_delivery.png";
import ElderlyCare from "../Logos/Elder&childcarePage/ElderlyCare.png";
import EmergencyCareSupport from "../Logos/EmergencyCareSupport/EmergencyCareSupport.png";
import ForSeniors from "../Logos/SocialWellness/ForSeniors.png";
import PhysiotherapyatHome from "../Logos/Nursing/PhysiotherapyatHome.png";
import Footer from "../Common/Footer";
import DiagnosticSampleCollection from "../Logos/DiagnoisticDelivery/DiagnosticSampleCollection.png";
import { fetchUserFromRedis } from "../HomePage/AuthonticationScreens/Register";
const API = process.env.REACT_APP_API_BASE_URL;
// const { HEALTH_PACKAGES, HEALTH_CAMPS } = healthData;
const services = [
  { id: "1", title: "ELDERLY AND CHILDCARE", subtitle: "Professional care for elderly and children at home", image: ElderlyCare, screen: "/elder-child-care" },
  { id: "2", title: "NURSING & PHYSIOTHERAPY", subtitle: "Expert nursing and physiotherapy at your doorstep", image: PhysiotherapyatHome, screen: "/NursingPhysioBooking" },
  { id: "3", title: "MEDICINE DELIVERY", subtitle: "Get your medicines delivered to your home quickly.", image: DoctorVisitPickupDrop, screen: "/medicine-order-type" },
  { id: "4", title: "EMERGENCY CARE SUPPORT", subtitle: "24/7 emergency medical care and support", image: EmergencyCareSupport, screen: "/emergencycare" },
  { id: "5", title: "DOCTOR VISIT & PICKUP/DROP", subtitle: "Doctor home visits and transportation services", image: DoctorVisitPickupDrop, screen: "/doctor-visit" },
  { id: "6", title: "SOCIAL WELLNESS ACTIVITIES", subtitle: "Engaging social and wellness programs", image: ForSeniors, screen: "/social-wellness-activities" },
  { id: "7", title: "DIAGNOSTIC SAMPLE COLLECTION", subtitle: "We collect your diagnostic samples from your home.", image: DiagnosticSample, screen: "/medicine-diagnostic" },
];

const ACTIVE_IDS = ["3", "7","2"];

const STATS = [
  { value: "50K+", label: "Patients Served", icon: "👥" },
  { value: "24/7", label: "Support", icon: "🕐" },
  { value: "200+", label: "Specialists", icon: "🩺" },
  { value: "5+", label: "Camps Done", icon: "🏕️" },
];

const HERO_CARDS = [
  { icon: "🔬", label: "Most Booked", title: "Diagnostic Tests", sub: "Home sample collection", badge: "Book Now", path: "/medicine-diagnostic" },
  { icon: "💊", label: "Fast Delivery", title: "Medicine Delivery", sub: "Delivered to your door", badge: "Order", path: "/medicine-order-type" },
];

const TIME_SLOTS = ["7:00 AM – 9:00 AM", "9:00 AM – 11:00 AM", "11:00 AM – 1:00 PM", "2:00 PM – 4:00 PM", "4:00 PM – 6:00 PM"];


const HeroOfferHighlight = ({ discountPct, HEALTH_PACKAGES, HEALTH_CAMPS, onPackageClick, onCampClick }) => {
  // Build the offer items from your real API data
  const items = [
    discountPct && {
      icon: "💊",
      badge: "🔥 Today's Deal",
      badgeColor: "#FFD166",
      badgeBg: "rgba(255,209,102,0.18)",
      badgeBorder: "rgba(255,209,102,0.4)",
      line1: `${discountPct}% OFF`,
      line1Color: "#FFD166",
      line2: "on all medicine orders",
      line2Color: "rgba(255,255,255,0.75)",
      glow: "rgba(255,209,102,0.25)",
      onClick: null,
    },
    ...[...(HEALTH_PACKAGES || [])].slice(-1).reverse().map(pkg => {
      const save = pkg.total && pkg.offerPrice
        ? Math.round(((pkg.total - pkg.offerPrice) / pkg.total) * 100) : 0;
      return {
        icon: pkg.icon || "🏥",
        badge: "✨ New Package",
        badgeColor: "#C084FC",
        badgeBg: "rgba(192,132,252,0.15)",
        badgeBorder: "rgba(192,132,252,0.35)",
        line1: pkg.name,
        line1Color: "#C084FC",
        line2: `₹${(pkg.offerPrice || 0).toLocaleString()} only · ${save}% OFF`,
        line2Color: "rgba(255,255,255,0.72)",
        glow: "rgba(192,132,252,0.22)",
        onClick: () => onPackageClick && onPackageClick(pkg),
      };
    }),
    ...(HEALTH_CAMPS || []).slice(-1).map(camp => ({
      icon: camp.icon || "🩺",
      badge: "📍 Free Camp",
      badgeColor: "#80ED99",
      badgeBg: "rgba(128,237,153,0.15)",
      badgeBorder: "rgba(128,237,153,0.35)",
      line1: camp.title,
      line1Color: "#80ED99",
      line2: camp.dates?.[0] ? `📅 ${camp.dates[0]}` : camp.subtitle || "",
      line2Color: "rgba(255,255,255,0.72)",
      glow: "rgba(128,237,153,0.22)",
      onClick: () => onCampClick && onCampClick(camp),
    })),
  ].filter(Boolean);

  const [current, setCurrent] = useState(0);
  const [visible, setVisible] = useState(true);
  const autoRef = useRef(null);

  useEffect(() => {
    if (items.length <= 1) return;
    autoRef.current = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrent(prev => (prev + 1) % items.length);
        setVisible(true);
      }, 500);
    }, 4000);
    return () => clearInterval(autoRef.current);
  }, [items.length]); // eslint-disable-line

  if (!items.length) return null;
  const item = items[current];

  return (
    <>
      <style>{OFFER_HIGHLIGHT_CSS}</style>
      <div
        className={`ofl-wrap ${visible ? "ofl-in" : "ofl-out"}`}
        style={{ "--glow": item.glow, cursor: item.onClick ? "pointer" : "default" }}
        onClick={item.onClick || undefined}
      >
        {/* glowing left accent bar */}
        <div className="ofl-bar" style={{ background: item.line1Color, boxShadow: `0 0 14px ${item.line1Color}` }} />

        {/* badge pill */}
        <span className="ofl-badge" style={{
          color: item.badgeColor,
          background: item.badgeBg,
          border: `1px solid ${item.badgeBorder}`,
        }}>
          <span className="ofl-badge-dot" style={{ background: item.badgeColor, boxShadow: `0 0 6px ${item.badgeColor}` }} />
          {item.badge}
        </span>

        {/* main offer row */}
        <div className="ofl-main">
          <span className="ofl-icon">{item.icon}</span>
          <div className="ofl-text">
            <span className="ofl-line1" style={{
              color: item.line1Color,
              textShadow: `0 0 24px ${item.line1Color}88`,
            }}>
              {item.line1}
            </span>
            <span className="ofl-line2" style={{ color: item.line2Color }}>
              {item.line2}
            </span>
          </div>
          {item.onClick && (
            <span className="ofl-arrow" style={{ color: item.line1Color, border: `1.5px solid ${item.badgeBorder}` }}>→</span>
          )}
        </div>

        {/* dot nav */}
        {items.length > 1 && (
          <div className="ofl-dots">
            {items.map((_, i) => (
              <button
                key={i}
                className="ofl-dot"
                style={{
                  width: i === current ? 20 : 5,
                  background: i === current ? items[i].line1Color : "rgba(255,255,255,0.22)",
                  boxShadow: i === current ? `0 0 8px ${items[i].line1Color}` : "none",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  clearInterval(autoRef.current);
                  setVisible(false);
                  setTimeout(() => { setCurrent(i); setVisible(true); }, 400);
                }}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};



const HeroSliderBanner = ({ camps, packages, discountPct, onCampClick, onPackageClick }) => {
  const scrollRef = useRef(null);
  const [activeIdx, setActiveIdx] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const dragStart = useRef(0);
  const scrollStart = useRef(0);

  const newest = packages.slice(-2).reverse();

  const slides = [
    discountPct && {
      id: "offer", type: "offer",
      gradient: "linear-gradient(135deg, #0A0F1E 0%, #0D3B4F 40%, #006D77 100%)",
      accentColor: "#80ED99", glowColor: "rgba(128,237,153,0.35)",
      tag: "🔥 TODAY'S OFFER", headline: `${discountPct}% OFF`,
      sub: "On Every Medicine Order",
      body: "Discount applied automatically at checkout — no coupon needed!",
      visual: "💊", bigNumber: `${discountPct}%`, bigLabel: "DISCOUNT",
      pills: ["🚚 Free Delivery", "⚡ Same Day", "💯 Genuine Medicines"],
      cta: null, ctaLabel: null,
    },
    ...newest.map((pkg) => {
      const save = Math.round(((pkg.total - pkg.offerPrice) / pkg.total) * 100);
      return {
        id: pkg.id, type: "package",
        gradient: pkg.gradient || "linear-gradient(135deg, #1A0533 0%, #4A1259 50%, #7C3AED 100%)",
        accentColor: pkg.accentColor || "#C084FC",
        glowColor: (pkg.accentColor || "#C084FC") + "55",
        tag: "✨ NEW PACKAGE", headline: pkg.name, sub: pkg.tagline,
        body: `${pkg.tests?.length} tests · Home sample collection included`,
        visual: pkg.icon || "🧬",
        bigNumber: `₹${pkg.offerPrice?.toLocaleString()}`,
        bigLabel: `Save ${save}%`, mrp: `₹${pkg.total?.toLocaleString()}`,
        pills: pkg.tests?.slice(0, 3).map(t => `✓ ${(typeof t === "string" ? t : t.name).slice(0, 24)}`),
        cta: () => onPackageClick(pkg), ctaLabel: "Book Package →",
      };
    }),
    ...camps.map((camp) => ({
      id: camp.id, type: "camp",
      gradient: camp.bg || "linear-gradient(135deg, #052E16 0%, #14532D 50%, #16A34A 100%)",
      accentColor: camp.accentColor || "#86EFAC",
      glowColor: (camp.accentColor || "#86EFAC") + "44",
      tag: "🏕️ FREE HEALTH CAMP", headline: camp.title, sub: camp.subtitle,
      body: camp.note || `Free camp · ${camp.tests?.length} tests included · Limited slots`,
      visual: camp.icon || "🏥",
      bigNumber: "FREE", bigLabel: `${camp.tests?.length} Tests`,
      pills: camp.dates?.map(d => `📅 ${d}`) || [],
      cta: () => onCampClick(camp), ctaLabel: "View Camp →",
    })),
  ].filter(Boolean);

  const total = slides.length;

  // Track active slide on scroll
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const onScroll = () => {
      const idx = Math.round(el.scrollLeft / el.clientWidth);
      setActiveIdx(idx);
    };
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, []);

  // Auto scroll
  useEffect(() => {
    if (isDragging) return;
    const t = setTimeout(() => {
      const el = scrollRef.current;
      if (!el) return;
      const next = (activeIdx + 1) % total;
      el.scrollTo({ left: next * el.clientWidth, behavior: "smooth" });
    }, 5000);
    return () => clearTimeout(t);
  }, [activeIdx, isDragging, total]);

  const goTo = (i) => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollTo({ left: i * el.clientWidth, behavior: "smooth" });
  };

  // Mouse drag
  const onMouseDown = (e) => {
    setIsDragging(true);
    dragStart.current = e.clientX;
    scrollStart.current = scrollRef.current.scrollLeft;
  };
  const onMouseMove = (e) => {
    if (!isDragging) return;
    const dx = dragStart.current - e.clientX;
    scrollRef.current.scrollLeft = scrollStart.current + dx;
  };
  const onMouseUp = () => setIsDragging(false);

  return (
    <>
      <style>{HSB_CSS}</style>
      <div className="hsb-root">

        {/* ── Scrollable track ── */}
        <div
          className="hsb-track"
          ref={scrollRef}
          onMouseDown={onMouseDown}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
          onMouseLeave={onMouseUp}
        >
          {slides.map((s, idx) => (
            <div
              key={s.id}
              className="hsb-slide"
              style={{ background: s.gradient }}
            >
              {/* BG layers */}
              <div className="hsb-grid" />
              <div className="hsb-orb1" style={{ background: s.glowColor }} />
              <div className="hsb-orb2" style={{ background: s.glowColor }} />
              <div className="hsb-sweep" />
              {[...Array(6)].map((_, i) => (
                <div key={i} className={`hsb-blob hsb-b${i+1}`}
                  style={{ background: s.accentColor + "10" }} />
              ))}

              {/* Slide content */}
              <div className="hsb-content">

                {/* ══ LEFT ══ */}
                <div className="hsb-left">
                  <div className="hsb-tag"
                    style={{ color: s.accentColor, borderColor: s.accentColor + "44", background: s.accentColor + "15" }}>
                    <span className="hsb-tag-dot" style={{ background: s.accentColor, boxShadow: `0 0 8px ${s.accentColor}` }} />
                    {s.tag}
                  </div>

                  <h2 className="hsb-headline">{s.headline}</h2>
                  <p className="hsb-sub">{s.sub}</p>
                  <p className="hsb-body">{s.body}</p>

                  <div className="hsb-pills">
                    {s.pills?.map((p, i) => (
                      <span key={i} className="hsb-pill"
                        style={{ borderColor: s.accentColor + "44", color: "rgba(255,255,255,0.82)" }}>
                        {p}
                      </span>
                    ))}
                  </div>

                  {s.cta && (
                    <button className="hsb-cta"
                      style={{ background: s.accentColor, color: "#000" }}
                      onClick={(e) => { e.stopPropagation(); s.cta(); }}>
                      {s.ctaLabel}
                    </button>
                  )}

                  {/* Slide counter */}
                  <div className="hsb-slide-num" style={{ color: s.accentColor + "88" }}>
                    {String(idx + 1).padStart(2, "0")} / {String(total).padStart(2, "0")}
                  </div>
                </div>

                {/* ══ RIGHT — Number card ══ */}
                <div className="hsb-right">
                  <div className="hsb-numcard"
                    style={{ borderColor: s.accentColor + "33", boxShadow: `0 0 80px ${s.glowColor}` }}>

                    <div className="hsb-ncglow" style={{ background: s.glowColor }} />
                    <div className="hsb-ring hsb-ra" style={{ borderColor: s.accentColor + "35" }} />
                    <div className="hsb-ring hsb-rb" style={{ borderColor: s.accentColor + "18" }} />
                    <div className="hsb-ring hsb-rc" style={{ borderColor: s.accentColor + "10" }} />

                    {/* Orbiting dots */}
                    {[0,1,2].map(i => (
                      <div key={i} className="hsb-orbit-dot"
                        style={{
                          background: s.accentColor,
                          boxShadow: `0 0 8px ${s.accentColor}`,
                          animationDelay: `${i * 1.2}s`,
                          animationDuration: `${4 + i}s`,
                        }} />
                    ))}

                    <div className="hsb-nc-icon-wrap"
                      style={{ background: s.accentColor + "18", borderColor: s.accentColor + "44" }}>
                      <span className="hsb-nc-icon">{s.visual}</span>
                    </div>

                    <div className="hsb-bignum"
                      style={{ color: s.accentColor, textShadow: `0 0 40px ${s.accentColor}66` }}>
                      {s.bigNumber}
                    </div>

                    {s.mrp && (
                      <span className="hsb-mrp">MRP <s>{s.mrp}</s></span>
                    )}

                    <div className="hsb-biglabel" style={{ color: s.accentColor + "cc" }}>
                      {s.bigLabel}
                    </div>

                    {/* Pulsing border */}
                    <div className="hsb-pulse-border"
                      style={{ borderColor: s.accentColor + "55",
                               boxShadow: `0 0 0 0 ${s.accentColor}44` }} />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* ══ Nav arrows ══ */}
        <button className="hsb-nav hsb-nl"
          style={{ "--ac": slides[activeIdx]?.accentColor }}
          onClick={() => goTo((activeIdx - 1 + total) % total)}>‹</button>
        <button className="hsb-nav hsb-nr"
          style={{ "--ac": slides[activeIdx]?.accentColor }}
          onClick={() => goTo((activeIdx + 1) % total)}>›</button>

        {/* ══ Footer ══ */}
        <div className="hsb-footer">

          {/* Dots */}
          <div className="hsb-dots">
            {slides.map((s, i) => (
              <button key={i}
                className={`hsb-dot ${i === activeIdx ? "hsb-dot-on" : ""}`}
                style={i === activeIdx ? {
                  background: s.accentColor,
                  width: 28,
                  boxShadow: `0 0 10px ${s.accentColor}`,
                } : {}}
                onClick={() => goTo(i)}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};







// ─── Booking Modal (with Razorpay) ────────────────────────────────────────────
const BookingModal = ({ pkg, onClose }) => {
  const [form, setForm] = useState({
    patient_name: "", phone: "", email: "", age: "", gender: "",
    address: "", pincode: "", preferred_date: "", preferred_time: "", notes: "",
  });
  const [loading, setLoading]           = useState(false);
  const [success, setSuccess]           = useState(null);
  const [error, setError]               = useState("");
  const [prefillLoaded, setPrefillLoaded] = useState(false);
  const [razorpayLoaded, setRazorpayLoaded] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [bookingId,setBookingId] =useState("")
  

  // ── Load Razorpay SDK (same pattern as your example) ──
  useEffect(() => {
    if (window.Razorpay) { setRazorpayLoaded(true); return; }
    const s = document.createElement("script");
    s.src = process.env.REACT_APP_RAZORPAY_SCRIPT; // "https://checkout.razorpay.com/v1/checkout.js"
    s.async = true;
    s.onload  = () => setRazorpayLoaded(true);
    s.onerror = () => setError("Failed to load payment gateway. Please refresh.");
    document.body.appendChild(s);
  }, []);

  // ── Prefill user details ──
  useEffect(() => {
    if (!pkg) return;
    const loadUser = async () => {
      try {
        const userId = sessionStorage.getItem("userId");
        const token  = sessionStorage.getItem("token");
        if (userId && token) {
          const user = await fetchUserFromRedis(userId, token);
          if (user) {
            setForm((prev) => ({
              ...prev,
              patient_name: user.name                    || user.full_name || "",
              phone:        user.phone                   || user.mobile    || "",
              email:        user.email                   || "",
              age:          user.age ? String(user.age)  : "",
              gender:       user.gender                  || "",
              address:      user.address?.address_line2  || "",
              pincode:      user.address?.pincode        || user.zip_code || "",
            }));
            setPrefillLoaded(true);
            return;
          }
        }
        const saved = sessionStorage.getItem("patient_prefill");
        if (saved) {
          const parsed = JSON.parse(saved);
          setForm((prev) => ({ ...prev, ...parsed }));
          setPrefillLoaded(true);
        }
      } catch (e) {
        console.error("prefill load:", e);
      }
    };
    loadUser();
  }, [pkg]);

  if (!pkg) return null;

  const savings     = pkg.total - pkg.offerPrice;
  const discountPct = Math.round((savings / pkg.total) * 100);
  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

   const handleInvoiceCreation=async(payload,booking_id)=>{
        try{
              const invoice_response = await axios.post(
                `${process.env.REACT_APP_API_INVOICE}/invoice/pos_invoice`,
                payload,
              );
        
            const invoice = invoice_response.data.invoice_details;
            if (invoice.storage_type === "s3") {
              // Open CloudFront URL
              window.open(invoice.cloudfront_url, "_blank");
            } else if (invoice.storage_type === "local") {
              try {
              const token = sessionStorage.getItem("token");
  
              const response = await axios.get(
                `${process.env.REACT_APP_API_INVOICE}/package-invoice/download/${booking_id}`,
                {
                  responseType: "blob",
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              );
  
              const blob = new Blob([response.data], { type: "application/pdf" });
              const url = window.URL.createObjectURL(blob);
  
              window.open(url, "_blank");
  
            } catch (error) {
              console.error("Invoice download failed:", error);
            }
            }
  
          }
          catch (error) {
              console.error("Invoice upload failed:", error);
            }
      }
  // ── Step 1: Validate → create Razorpay order on backend ──
  const handleSubmitOrPay = async () => {
    // ── Validation ────────────────────────────────────────────────────────────
    const missing = [];
    if (!form.patient_name.trim()) missing.push("Full Name");
    if (!form.phone.trim())        missing.push("Phone Number");
    if (!form.preferred_date)      missing.push("Preferred Date");
    if (!form.preferred_time)      missing.push("Preferred Time Slot");
    if (missing.length > 0) { setError(`Please fill: ${missing.join(", ")}`); return; }
  
    setError("");
    setLoading(true);
  
    // ── CASH — Flask /create (unchanged) ─────────────────────────────────────
    if (paymentMethod === "cash") {
      try {
        const res = await axios.post(`${API}/package-orders/create`, {
          package_id:     pkg.id,
          package_name:   pkg.name,
          mrp:            pkg.total,
          payment_method: "cash",
          ...form,
          age: form.age ? parseInt(form.age) : null,
        });
        localStorage.setItem("patient_prefill", JSON.stringify({
          patient_name: form.patient_name, phone: form.phone,
          email: form.email, age: form.age, gender: form.gender,
          address: form.address, pincode: form.pincode,
        }));
        setSuccess(res.data.booking);
        setBookingId(res.data.booking.booking_ref)
          const packageBookingData={
          service_type:"package",
          order_id: res.data.booking.booking_ref,
          items: pkg.name,
          patient_details: form,
          subtotal: pkg.total,
          discount:  savings,
          total_amount: pkg.total-savings,
          payment: { method: paymentMethod },
          created_at: new Date().toISOString()
        }
        handleInvoiceCreation(packageBookingData,res.data.booking.booking_ref)
      } catch (err) {
        setError(err.response?.data?.error || "Booking failed. Please try again.");
      }
      setLoading(false);
      return;
    }
  
    // ── ONLINE — FastAPI Razorpay (mirrors medicine flow exactly) ────────────
    if (!razorpayLoaded || !window.Razorpay) {
      setError("Payment gateway is loading. Please try again.");
      setLoading(false);
      return;
    }
  
    try {
      // Step 1: Create Razorpay order via FastAPI (same endpoint as medicine)
      const orderRes = await axios.post(process.env.REACT_APP_CREATE_RAZORPAY_ORDER, {
        amount:   pkg.offerPrice,
        currency: "INR",
        receipt:  `pkg_${Date.now()}`,
        notes: {
          order_type:    "package_booking",
          package_id:    pkg.id,
          package_name:  pkg.name,
          patient_name:  form.patient_name,
          phone:         form.phone,
        },
      });
  
      if (!orderRes.data?.id) throw new Error("Failed to create payment order");
      setLoading(false);
      setBookingId(orderRes.data.id)

      // Step 2: Open Razorpay checkout (same pattern as medicine)
      const rzp = new window.Razorpay({
        key:         process.env.REACT_APP_RAZORPAY_KEY,
        currency:    "INR",
        name:        "Ayuja Life Services",
        description: pkg.name,
        order_id:    orderRes.data.id,
        prefill: {
          name:    form.patient_name,
          email:   form.email,
          contact: form.phone,
        },
        theme: { color: pkg.accentColor || "#006D77" },
  
        handler: async (paymentSuccess) => {
          setLoading(true);
          try {
            // Step 3: Verify via FastAPI (same endpoint as medicine)
            const verifyRes = await axios.post(process.env.REACT_APP_PROCESS_PAYEMENT, {
              razorpay_payment_id: paymentSuccess.razorpay_payment_id,
              razorpay_order_id:   paymentSuccess.razorpay_order_id,
              razorpay_signature:  paymentSuccess.razorpay_signature,
            });
  
            if (verifyRes.data?.status !== "success") throw new Error("Payment verification failed");
  
            // Step 4: Save booking via Flask /confirm-payment
            const confirmRes = await axios.post(`${API}/package-orders/confirm-payment`, {
              razorpay_order_id:   paymentSuccess.razorpay_order_id,
              razorpay_payment_id: paymentSuccess.razorpay_payment_id,
              razorpay_signature:  paymentSuccess.razorpay_signature,
              package_id:          pkg.id,
              package_name:        pkg.name,
              mrp:                 pkg.total,
              ...form,
              age: form.age ? parseInt(form.age) : null,
            });
  
            localStorage.setItem("patient_prefill", JSON.stringify({
              patient_name: form.patient_name, phone: form.phone,
              email: form.email, age: form.age, gender: form.gender,
              address: form.address, pincode: form.pincode,
            }));
  
            setSuccess(confirmRes.data.booking);
            const packageBookingData={
              service_type:"package",
              order_id: bookingId,
              items: pkg.name,
              patient_details: form,
              subtotal: pkg.total,
              discount:  savings,
              total_amount: pkg.total-savings,
              payment: { method: paymentMethod },
              created_at: new Date().toISOString()
            }
            handleInvoiceCreation(packageBookingData,orderRes.data.id)

          } catch (err) {
            setError(
              "Payment received but booking failed. Contact support with Payment ID: " +
              paymentSuccess.razorpay_payment_id
            );
          }
          setLoading(false);
        },
  
        modal: {
          ondismiss: () => {
            setLoading(false);
            setError("Payment cancelled. You can try again or choose Cash on Completion.");
          },
        },
      });
  
      rzp.on("payment.failed", (r) => {
        setLoading(false);
        setError(`Payment failed: ${r.error.description || r.error.message}`);
      });
  
      rzp.open();
  
    } catch (err) {
      setError(err.response?.data?.detail || err.message || "Could not initiate payment.");
      setLoading(false);
    }
  };

  // ── Success screen ── (same as before, just add payment_id row)
  if (success) return (
    <div style={BM.overlay} onClick={onClose}>
      <div style={BM.box} onClick={(e) => e.stopPropagation()}>
        <div style={{ ...BM.hero, background: pkg.gradient }}>
          <div style={BM.hd1}/><div style={BM.hd2}/>
          <div style={{ textAlign:"center", padding:"32px 24px", position:"relative", zIndex:1 }}>
            <div style={{ fontSize:60, marginBottom:12 }}>✅</div>
            <h2 style={{ fontFamily:"'Sora',sans-serif", fontSize:22, fontWeight:900, color:"#fff", marginBottom:8 }}>Booking Confirmed!</h2>
            <p style={{ fontSize:14, color:"rgba(255,255,255,0.8)", marginBottom:16 }}>Payment received & slot reserved successfully.</p>
            <div style={{ background:"rgba(255,255,255,0.15)", borderRadius:14, padding:"14px 20px", display:"inline-block" }}>
              <span style={{ fontSize:13, color:"rgba(255,255,255,0.7)" }}>Booking Ref</span>
              <div style={{ fontFamily:"monospace", fontSize:22, fontWeight:900, color:"#80ED99" }}>{success.booking_ref}</div>
            </div>
          </div>
        </div>
        <div style={{ padding:"24px 28px 28px" }}>
          <div style={BM.successGrid}>
            {[
              ["Patient",       success.patient_name],
              ["Package",       success.package_name],
              ["Paid",          `₹${success.offer_price?.toLocaleString()}`],
              ["Savings",       `₹${success.savings?.toLocaleString()}`],
              ["Date",          success.preferred_date],
              ["Time",          success.preferred_time],
              ["Payment",  success.payment_method === "online"
                ? `✅ Paid Online (${success.razorpay_payment_id || "—"})`
                : "💵 Cash on Completion"],
              ["Status",   success.status],
              ["Payment ID",    success.razorpay_payment_id || "—"],  // ← new
            ].map(([label, value]) => (
              <div key={label} style={BM.successItem}>
                <span style={BM.successLabel}>{label}</span>
                <span style={BM.successValue}>{value}</span>
              </div>
            ))}
          </div>
          <p style={{ fontSize:13, color:"#64748B", textAlign:"center", marginTop:16, marginBottom:20 }}>
            Our team will call you to confirm the appointment. Save your booking reference!
          </p>
          <button style={{ ...BM.submitBtn, background: pkg.gradient }} onClick={onClose}>Done</button>
        </div>
      </div>
    </div>
  );

  // ── Form screen ── (identical to yours — only the submit button changes)
  return (
    <div style={BM.overlay} onClick={onClose}>
      <div style={BM.box} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div style={{ ...BM.hero, background: pkg.gradient }}>
          <div style={BM.hd1}/><div style={BM.hd2}/>
          <button style={BM.closeBtn} onClick={onClose}>✕</button>
          <div style={{ position:"relative", zIndex:1 }}>
            <div style={{ fontSize:36, marginBottom:8 }}>{pkg.icon}</div>
            <h2 style={{ fontFamily:"'Sora',sans-serif", fontSize:18, fontWeight:800, color:"#fff", marginBottom:6 }}>Book {pkg.name}</h2>
            <div style={{ display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
              <span style={{ fontFamily:"'Sora',sans-serif", fontSize:24, fontWeight:900, color: pkg.accentColor }}>
                ₹{pkg.offerPrice.toLocaleString()}
              </span>
              <span style={{ fontSize:15, color:"rgba(255,255,255,0.55)", textDecoration:"line-through" }}>
                ₹{pkg.total.toLocaleString()}
              </span>
              <span style={{ background:"#10B981", color:"#fff", fontSize:12, fontWeight:800, padding:"3px 10px", borderRadius:20 }}>
                {discountPct}% OFF — Save ₹{savings.toLocaleString()}
              </span>
            </div>
          </div>
        </div>

        {/* Form body — unchanged from your original */}
        <div style={BM.body}>
          {prefillLoaded && form.patient_name && (
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:10, background:"#ECFDF5", border:"1px solid #A7F3D0", borderRadius:10, padding:"10px 14px", marginBottom:16 }}>
              <span style={{ fontSize:13, color:"#065F46" }}>✅ Details prefilled from your profile. You can edit any field.</span>
              <button style={{ background:"none", border:"none", fontSize:12, fontWeight:700, color:"#059669", cursor:"pointer", flexShrink:0 }}
                onClick={() => { setForm((f) => ({ ...f, patient_name:"", phone:"", email:"", age:"", gender:"", address:"", pincode:"" })); setPrefillLoaded(false); }}>
                Clear
              </button>
            </div>
          )}

          <p style={BM.sectionTitle}>👤 Patient Details</p>
          <div style={BM.formGrid}>
            <div style={BM.formGroup}><label style={BM.label}>Full Name *</label><input style={BM.input} name="patient_name" placeholder="Enter full name" value={form.patient_name} onChange={handleChange} /></div>
            <div style={BM.formGroup}><label style={BM.label}>Phone Number *</label><input style={BM.input} name="phone" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={handleChange} /></div>
            <div style={BM.formGroup}><label style={BM.label}>Email</label><input style={BM.input} name="email" placeholder="email@example.com" value={form.email} onChange={handleChange} /></div>
            <div style={BM.formGroup}><label style={BM.label}>Age</label><input style={BM.input} name="age" type="number" placeholder="Age" value={form.age} onChange={handleChange} /></div>
            <div style={BM.formGroup}><label style={BM.label}>Gender</label><select style={BM.input} name="gender" value={form.gender} onChange={handleChange}><option value="">Select</option><option>Male</option><option>Female</option><option>Other</option></select></div>
            <div style={BM.formGroup}><label style={BM.label}>Pincode</label><input style={BM.input} name="pincode" placeholder="6-digit pincode" value={form.pincode} onChange={handleChange} /></div>
          </div>
          <div style={{ ...BM.formGroup, marginBottom:16 }}><label style={BM.label}>Address</label><textarea style={{ ...BM.input, height:72, resize:"vertical" }} name="address" placeholder="Full collection address" value={form.address} onChange={handleChange} /></div>

          <p style={BM.sectionTitle}>📅 Schedule</p>
          <div style={BM.formGrid}>
            <div style={BM.formGroup}><label style={BM.label}>Preferred Date *</label><input style={BM.input} name="preferred_date" type="date" value={form.preferred_date} min={new Date().toISOString().split("T")[0]} onChange={handleChange} /></div>
            <div style={BM.formGroup}><label style={BM.label}>Preferred Time Slot *</label><select style={BM.input} name="preferred_time" value={form.preferred_time} onChange={handleChange}><option value="">Select slot</option>{TIME_SLOTS.map((t) => <option key={t}>{t}</option>)}</select></div>
          </div>
          <div style={{ ...BM.formGroup, marginBottom:20 }}><label style={BM.label}>Special Notes</label><textarea style={{ ...BM.input, height:60, resize:"vertical" }} name="notes" placeholder="Any special requirements or health notes..." value={form.notes} onChange={handleChange} /></div>

          <p style={BM.sectionTitle}>💳 Payment Method</p>
            <div style={{ display:"flex", gap:12, marginBottom:20 }}>
              {[
                { id:"cash",   icon:"💵", label:"Cash on Completion", sub:"Pay after sample collection" },
                { id:"online", icon:"💳", label:"Pay Online",         sub:"Secure payment via Razorpay"  },
              ].map((opt) => (
                <div
                  key={opt.id}
                  onClick={() => setPaymentMethod(opt.id)}
                  style={{
                    flex: 1,
                    border: `2px solid ${paymentMethod === opt.id ? (pkg.accentColor || "#006D77") : "#E2E8F0"}`,
                    borderRadius: 12,
                    padding: "14px 12px",
                    cursor: "pointer",
                    background: paymentMethod === opt.id ? (pkg.accentColor || "#006D77") + "12" : "#F8FAFC",
                    transition: "all 0.2s",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: 24, marginBottom: 4 }}>{opt.icon}</div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: paymentMethod === opt.id ? (pkg.accentColor || "#006D77") : "#0F172A", marginBottom: 2 }}>{opt.label}</div>
                  <div style={{ fontSize: 11, color: "#64748B" }}>{opt.sub}</div>
                  {paymentMethod === opt.id && (
                    <div style={{ marginTop: 6, fontSize: 11, fontWeight: 800, color: pkg.accentColor || "#006D77" }}>✓ Selected</div>
                  )}
                </div>
              ))}
            </div>

          {error && <div style={BM.errorBox}>⚠️ {error}</div>}

          {/* ── PAY NOW button replaces the old Confirm button ── */}
          <button
          style={{ ...BM.submitBtn, background: pkg.gradient, opacity: loading || (paymentMethod === "online" && !razorpayLoaded) ? 0.7 : 1 }}
          onClick={handleSubmitOrPay}
          disabled={loading || (paymentMethod === "online" && !razorpayLoaded)}
        >
          {loading
            ? "⏳ Please wait..."
            : paymentMethod === "cash"
              ? `✅ Confirm Booking — Pay ₹${pkg.offerPrice.toLocaleString()} on Completion`
              : !razorpayLoaded
                ? "⏳ Loading Gateway..."
                : `💳 Pay ₹${pkg.offerPrice.toLocaleString()} — Secure Checkout`}
        </button>
          <button style={BM.cancelBtn} onClick={onClose}>Maybe Later</button>
        </div>
      </div>
    </div>
  );
};

// ─── Package Detail Modal ──────────────────────────────────────────────────────
const PackageModal = ({ pkg, onClose, onBook }) => {
  if (!pkg) return null;
  const savings = pkg.total - pkg.offerPrice;
  const discountPct = Math.round((savings / pkg.total) * 100);

  return (
    <div style={PM.overlay} onClick={onClose}>
      <div style={PM.box} onClick={(e) => e.stopPropagation()}>
        <div style={{ ...PM.hero, background: pkg.gradient }}>
          <div style={PM.hd1} /><div style={PM.hd2} />
          <button style={PM.closeBtn} onClick={onClose}>✕</button>
          <div style={PM.tierBadge}>
            <span style={{ ...PM.tierDot, backgroundColor: pkg.accentColor }} />
            {pkg.tier}
          </div>
          <div style={PM.heroIcon}>{pkg.icon}</div>
          <h2 style={PM.heroTitle}>{pkg.name}</h2>
          <p style={PM.heroSub}>{pkg.tagline}</p>

          {/* Price block with strikethrough */}
          <div style={PM.priceBlock}>
            <div style={PM.priceLeft}>
              <span style={PM.priceHeroLabel}>Offer Price</span>
              <span style={{ ...PM.priceHeroValue, color: pkg.accentColor }}>₹{pkg.offerPrice.toLocaleString()}</span>
              <span style={PM.strikeMRP}>MRP: ₹{pkg.total.toLocaleString()}</span>
            </div>
            <div style={{ ...PM.savingsBadge, background:"rgba(16,185,129,0.2)", border:"1px solid rgba(16,185,129,0.4)" }}>
              <span style={{ fontSize:11, color:"#80ED99", fontWeight:700 }}>YOU SAVE</span>
              <span style={{ fontSize:20, fontWeight:900, color:"#80ED99" }}>₹{savings.toLocaleString()}</span>
              <span style={{ fontSize:13, color:"#80ED99", fontWeight:700 }}>{discountPct}% OFF</span>
            </div>
          </div>
        </div>

        <div style={PM.body}>
          <p style={PM.testsLabel}>🔬 Included Tests ({pkg.tests.length})</p>
          <div style={PM.testsTable}>
            <div style={{ ...PM.tableRow, ...PM.tableHead }}>
              {/* <span style={PM.colCode}>Code</span> */}
              <span style={PM.colName}>Test Name</span>
              {/* <span style={PM.colPrice}>MRP</span> */}
            </div>
            {pkg.tests.map((t, i) => (
              <div key={i} style={{ ...PM.tableRow, backgroundColor: i % 2 === 0 ? "#F8FAFC" : "#FFFFFF" }}>
                {/* <span style={PM.colCode}><code style={PM.codeTag}>{t.code}</code></span> */}
                <span style={PM.colName}>{t.name}</span>
                {/* <span style={{ ...PM.colPrice, color: "#006D77", fontWeight: 700 }}>₹{t.mrp}</span> */}
              </div>
            ))}
            <div style={{ ...PM.tableRow, ...PM.totalRow }}>
              <span style={PM.colCode} />
              <span style={{ ...PM.colName, fontWeight: 800, color: "#0F172A" }}>Total MRP</span>
              <span style={{ ...PM.colPrice, fontWeight: 900, color: "#94A3B8", fontSize: 16, textDecoration:"line-through" }}>₹{pkg.total.toLocaleString()}</span>
            </div>
            <div style={{ ...PM.tableRow, background:"#ECFDF5", borderTop:"2px solid #A7F3D0" }}>
              <span style={PM.colCode} />
              <span style={{ ...PM.colName, fontWeight: 800, color: "#059669" }}>Offer Price</span>
              <span style={{ ...PM.colPrice, fontWeight: 900, color: "#059669", fontSize: 20 }}>₹{pkg.offerPrice.toLocaleString()}</span>
            </div>
          </div>
          <button style={{ ...PM.bookBtn, background: pkg.gradient }} onClick={() => { onBook(pkg); onClose(); }}>
            🔬 Book This Package — ₹{pkg.offerPrice.toLocaleString()}
          </button>
          <button style={PM.closeText} onClick={onClose}>Maybe Later</button>
        </div>
      </div>
    </div>
  );
};

// ─── Package Card ──────────────────────────────────────────────────────────────
const PackageCard = ({ pkg, onClick }) => {
  const [hov, setHov] = useState(false);
  const preview = pkg.tests.slice(0, 4);
  const savings = pkg.total - pkg.offerPrice;
  const discountPct = Math.round((savings / pkg.total) * 100);

  return (
    <div
      style={{ ...PKC.card,height: "100%", transform: hov ? "translateY(-8px)" : "translateY(0)", boxShadow: hov ? "0 28px 56px rgba(0,0,0,0.18)" : "0 6px 24px rgba(0,0,0,0.08)" }}
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
    >
      <div style={{ ...PKC.gradientStrip, background: pkg.gradient }}>
        <div style={PKC.sd1} /><div style={PKC.sd2} />

        {/* Discount ribbon */}
        <div style={PKC.discountRibbon}>{discountPct}% OFF</div>

        <div style={PKC.topRow}>
          <span style={{ ...PKC.tierBadge, backgroundColor: pkg.badgeBg, color: pkg.badgeColor }}>{pkg.icon} {pkg.tier}</span>
        </div>
        <h3 style={PKC.name}>{pkg.name}</h3>
        <p style={PKC.tagline}>{pkg.tagline}</p>

        {/* Offer + Strike MRP */}
        <div style={PKC.priceRow}>
          <span style={{ ...PKC.offerPrice, color: pkg.accentColor }}>₹{pkg.offerPrice.toLocaleString()}</span>
          <span style={PKC.strikeMRP}>₹{pkg.total.toLocaleString()}</span>
          <span style={PKC.savingsChip}>Save ₹{savings.toLocaleString()}</span>
        </div>
      </div>

      <div style={PKC.body}>
        <p style={PKC.testsLabel}>Includes {pkg.tests.length} tests:</p>
        <div style={PKC.testsList}>
          {preview.map((t, i) => (
            <div key={i} style={PKC.testRow}>
              <span style={{ ...PKC.dot, backgroundColor: pkg.badgeColor }} />
              <span style={PKC.testName} title={t.name}>{t.name.length > 50 ? t.name.slice(0, 50) + "…" : t.name}</span>
              {/* <span style={PKC.testPrice}>₹{t.mrp}</span> */}
            </div>
          ))}
          {pkg.tests.length > 4 && <p style={PKC.more}>+{pkg.tests.length - 4} more tests included</p>}
        </div>
        <div style={PKC.footer}>
          <div style={PKC.footerLeft}>
            <span style={PKC.totalLabel}>Offer Price</span>
            <div style={{ display:"flex", alignItems:"baseline", gap:8 }}>
              <span style={{ ...PKC.totalValue, color: pkg.badgeColor }}>₹{pkg.offerPrice.toLocaleString()}</span>
              <span style={{ fontSize:12, color:"#94A3B8", textDecoration:"line-through" }}>₹{pkg.total.toLocaleString()}</span>
            </div>
          </div>
          <button style={{ ...PKC.viewBtn, background: pkg.gradient }} onClick={() => onClick(pkg)}>
            View Details →
          </button>
        </div>
      </div>
    </div>
  );
};

// ─── Camp Modal ────────────────────────────────────────────────────────────────
const CampModal = ({ camp, onClose }) => {
  if (!camp) return null;
  return (
    <div style={M.overlay} onClick={onClose}>
      <div style={M.box} onClick={(e) => e.stopPropagation()}>
        <div style={{ ...M.hero, background: camp.bg }}>
          <div style={M.hd1} /><div style={M.hd2} />
          <button style={M.closeBtn} onClick={onClose}>✕</button>
          <span style={{ ...M.badge, backgroundColor: camp.badgeColor }}>{camp.badge}</span>
          <div style={M.heroIcon}>{camp.icon}</div>
          <h2 style={M.heroTitle}>{camp.title}</h2>
          <p style={M.heroSub}>{camp.subtitle}</p>
        </div>
        <div style={M.body}>
          <p style={M.sectionLabel}>✅ Included Tests & Services</p>
          {camp.dates && camp.dates.length > 0 && (
            <div style={{ display:"flex", alignItems:"center", gap:10, flexWrap:"wrap", marginBottom:20 }}>
              <span style={{ fontSize:14, fontWeight:700, color:"#0F172A" }}>📅 Camp Dates:</span>
              {camp.dates.map((d, i) => (
                <span key={i} style={{ backgroundColor:"#ECFDF5", color:"#059669", border:"1.5px solid #A7F3D0", fontSize:14, fontWeight:900, padding:"6px 16px", borderRadius:10, letterSpacing:0.5 }}>{d}</span>
              ))}
            </div>
          )}
          <div style={M.testGrid}>
            {camp.tests.map((t, i) => (
              <div key={i} style={M.testChip}>
                <span style={{ ...M.chipDot, backgroundColor: camp.accentColor }} />
                <span style={M.chipText}>{t}</span>
              </div>
            ))}
          </div>
          <div style={M.noteBox}>
            <p style={M.noteText}>💡 {camp.note}</p>
            <p style={M.tagline}>📅 {camp.tagline}</p>
          </div>
          <a href={`tel:${camp.phone.replace(/\s/g, "")}`} style={{ textDecoration:"none" }}>
            <button style={{ ...M.callBtn, background: camp.bg }}>📞 &nbsp;Call Us: {camp.phone}</button>
          </a>
          {camp.website && <p style={{ textAlign:"center", fontSize:13, color:"#64748B", marginBottom:8 }}>🌐 {camp.website}</p>}
          <button style={M.closeText} onClick={onClose}>Maybe Later</button>
        </div>
      </div>
    </div>
  );
};

// ─── Camp Card ─────────────────────────────────────────────────────────────────
const CampCard = ({ camp, onClick }) => {
  const [hov, setHov] = useState(false);
  return (
    <div
      style={{ ...CC.card, background: camp.bg, transform: hov ? "translateY(-8px) scale(1.02)" : "translateY(0) scale(1)", boxShadow: hov ? "0 24px 48px rgba(0,0,0,0.28)" : "0 8px 24px rgba(0,0,0,0.18)" }}
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      onClick={() => onClick(camp)}
    >
      <div style={CC.d1} /><div style={CC.d2} />
      <span style={{ ...CC.badge, backgroundColor: camp.badgeColor }}>{camp.badge}</span>
      <div style={CC.icon}>{camp.icon}</div>
      <h3 style={CC.title}>{camp.title}</h3>
      <p style={CC.subtitle}>{camp.subtitle}</p>
      {camp.dates && camp.dates.length > 0 && (
        <div style={{ display:"flex", gap:8, marginBottom:14, flexWrap:"wrap", position:"relative", zIndex:1 }}>
          <span style={{ fontSize:10, fontWeight:700, color:"rgba(255,255,255,0.6)", alignSelf:"center", textTransform:"uppercase", letterSpacing:0.5 }}>Camp Day:</span>
          {camp.dates.map((d, i) => (
            <span key={i} style={{ backgroundColor: camp.accentColor, color:"#003D45", fontSize:12, fontWeight:900, padding:"4px 12px", borderRadius:8, letterSpacing:0.5 }}>{d}</span>
          ))}
        </div>
      )}
      <div style={CC.tests}>
        {camp.tests.slice(0, 3).map((t, i) => (
          <div key={i} style={CC.testRow}>
            <span style={{ ...CC.check, color: camp.accentColor }}>✓</span>
            <span style={CC.testText}>{t}</span>
          </div>
        ))}
        {camp.tests.length > 3 && <p style={CC.more}>+{camp.tests.length - 3} more tests</p>}
      </div>
      <div style={CC.footer}>
        <p style={CC.tagline}>{camp.tagline}</p>
        <span style={{ ...CC.viewBtn, color: camp.accentColor, borderColor: camp.accentColor + "66" }}>View Details →</span>
      </div>
    </div>
  );
};

// ─── Service Card ──────────────────────────────────────────────────────────────
const ServiceCard = ({ service, isActive, onNavigate, priceLabel }) => {
  const [hov, setHov] = useState(false);
  return (
    <div
      style={{ ...SC.card, opacity: isActive ? 1 : 0.45, cursor: isActive ? "pointer" : "default", transform: hov && isActive ? "translateY(-6px)" : "translateY(0)", boxShadow: hov && isActive ? "0 20px 48px rgba(0,109,119,0.22)" : "0 4px 18px rgba(0,0,0,0.08)" }}
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      onClick={() => isActive && onNavigate(service.screen)}
    >
      {isActive && <div style={SC.topBar} />}
      <div style={SC.imgWrap}>
        <img src={service.image} alt={service.title} style={SC.img} />
        {isActive && <span style={SC.dot} />}
        {!isActive && <div style={SC.comingSoon}><span style={SC.comingText}>Coming Soon</span></div>}
      </div>
      <div style={SC.body}>
        <h3 style={SC.title}>{service.title}</h3>
        <p style={SC.sub}>{service.subtitle}</p>
        {priceLabel && isActive && <p style={SC.price}>{priceLabel}</p>}
        <div style={{ ...SC.btn, backgroundColor: isActive ? "#006D77" : "#94A3B8" }}>
          <span style={SC.btnTxt}>{isActive ? (service.title.includes("MEDICINE") ? "Order Medicine →" : "Book Now →") : "Unavailable"}</span>
        </div>
      </div>
    </div>
  );
};

// ─── Main ─────────────────────────────────────────────────────────────────────
const ServiceSelectionScreen = () => {
  const navigate = useNavigate();
  const [servicePrices, setServicePrices] = useState([]);
  const [selectedCamp, setSelectedCamp] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [bookingPackage, setBookingPackage] = useState(null);
  const campRef = useRef(null);
  const [canL, setCanL] = useState(false);
  const [canR, setCanR] = useState(true);


  const [HEALTH_CAMPS,    setHealthCamps]    = useState([]);
  const [HEALTH_PACKAGES, setHealthPackages] = useState([]);
  const [contentLoading,  setContentLoading] = useState(true);

  const bannerRef = useRef(null);
  const [campIndex, setCampIndex] = useState(0);
  const [discountPct, setDiscountPct] = useState(null);
  const [recentPackages, setRecentPackages] = useState([]);

  const pkgRef = useRef(null);
const [pkgCanL, setPkgCanL] = useState(false);
const [pkgCanR, setPkgCanR] = useState(true);

const scrollPkg = (dir) => {
  const el = pkgRef.current;
  if (!el) return;
  el.scrollBy({ left: dir * 360, behavior: "smooth" });
  setTimeout(() => {
    setPkgCanL(el.scrollLeft > 0);
    setPkgCanR(el.scrollLeft < el.scrollWidth - el.clientWidth - 10);
  }, 350);
};

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    fetch(`${API}/medicine/admin/ayuja-config`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((r) => r.json())
      .then((d) => setDiscountPct(d.configured_offered_discount_pct))
      .catch(console.error);
  }, []);

  useEffect(() => {
    const fetchContent = async () => {
      setContentLoading(true);
      try {
        const [campsRes, pkgsRes] = await Promise.all([
          fetch(`${API}/health-camp/camps`),
          fetch(`${API}/health-camp/packages`),
        ]);
        const campsData = await campsRes.json();
        const pkgsData  = await pkgsRes.json();
        if (campsData.success) setHealthCamps(campsData.camps       || []);
        if (pkgsData.success) {
          const pkgs = pkgsData.packages || [];
          setHealthPackages(pkgs);
          // Take last 3 as "recently added" (assumes API returns oldest→newest)
          setRecentPackages(pkgs.slice(-3).reverse());
        }
        // if (pkgsData.success)  setHealthPackages(pkgsData.packages  || []);
      } catch (err) {
        console.error("Failed to load health content:", err);
      } finally {
        setContentLoading(false);
      }
    };
    fetchContent();
  }, []);

  useEffect(() => {
    if (!HEALTH_CAMPS.length) return;    
    const interval = setInterval(() => {
      setCampIndex((prev) => (prev + 1) % HEALTH_CAMPS.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [HEALTH_CAMPS.length]);
  

  useEffect(() => {
    axios.get(process.env.REACT_APP_GET_SERVICES).then((r) => setServicePrices(r.data)).catch(console.error);
  }, []);

  useEffect(() => {
    const el = bannerRef.current;
    if (!el) return;
  
    let isDown = false;
    let startX = 0;
  
    const onMouseDown = (e) => {
      isDown = true;
      startX = e.clientX;
    };
  
    const onMouseUp = (e) => {
      if (!isDown) return;
      isDown = false;
      const dx = e.clientX - startX;
      if (Math.abs(dx) < 30) return; // ignore tiny movements (treat as click)
      if (dx < 0) {
        // dragged left → next slide
        setCampIndex((prev) => (prev + 1) % HEALTH_CAMPS.length);
      } else {
        // dragged right → prev slide
        setCampIndex((prev) => (prev - 1 + HEALTH_CAMPS.length) % HEALTH_CAMPS.length);
      }
    };
  
    const onMouseLeave = () => { isDown = false; };
  
    el.addEventListener("mousedown", onMouseDown);
    el.addEventListener("mouseup", onMouseUp);
    el.addEventListener("mouseleave", onMouseLeave);
  
    return () => {
      el.removeEventListener("mousedown", onMouseDown);
      el.removeEventListener("mouseup", onMouseUp);
      el.removeEventListener("mouseleave", onMouseLeave);
    };
  }, []);

const CAMP_IMAGES = [
  ElderlyCare,
  DiagnosticSampleCollection,
  DoctorVisitPickupDrop,
  DiagnosticSample,
  DiagnosticSampleCollection
];

const CAMP_GRADIENTS = [
  "linear-gradient(135deg, #006D77 0%, #008B98 50%, #00A3B4 100%)",
  "linear-gradient(135deg, #003D45 0%, #006D77 50%, #008B98 100%)",
  "linear-gradient(135deg, #005F68 0%, #007A85 50%, #009BAA 100%)",
  "linear-gradient(135deg, #004E57 0%, #006D77 50%, #008B98 100%)",
  "linear-gradient(135deg, #007A85 0%, #009BAA 50%, #00BDD1 100%)",
];

const TrustIcon = ({ type }) => {
  const icons = {
    collection: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>
      </svg>
    ),
    reports: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14,2 14,8 20,8"/><line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/><polyline points="10,9 9,9 8,9"/>
      </svg>
    ),
    counselling: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
      </svg>
    ),
  };
  return icons[type] || null;
};



  const getPriceLabel = (name) => {
    const norm = (s) => s.replace(/[^a-z0-9]/gi, "").toLowerCase();
    const m = servicePrices.find((s) => norm(s.name) === norm(name));
    return m ? `From ₹${m.price.toFixed(0)}` : null;
  };

  const sorted = [
    ...services.filter((s) => ACTIVE_IDS.includes(s.id)),
    ...services.filter((s) => !ACTIVE_IDS.includes(s.id)),
  ];

  const scroll = (dir) => {
    const el = campRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * 340, behavior: "smooth" });
    setTimeout(() => { setCanL(el.scrollLeft > 0); setCanR(el.scrollLeft < el.scrollWidth - el.clientWidth - 10); }, 350);
  };

  const handleBookPackage = (pkg) => setBookingPackage(pkg);
  const campsSectionRef = useRef(null);
  const [flashCamps, setFlashCamps] = useState(false);

  const handleHeroClick = () => {
    // Trigger flash
    setFlashCamps(true);
    setTimeout(() => setFlashCamps(false), 1200); // flash duration
    // Optionally scroll to camps section
    if (campsSectionRef.current) {
      campsSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <>

      <style>{CSS}</style>
      {/* ── DISCOUNT FLASH BANNER ── */}

{discountPct && (
  <div className="discount-flash-bar">
    <div className="discount-flash-track">
    <div className="discount-flash-marquee">
          <span className="discount-flash-badge">🎉 {discountPct}% OFF</span>
          <span className="discount-flash-text">Get {discountPct}% off on all Medicine Orders — Limited Time Offer!</span>
          <span className="discount-flash-dot" />
          <span className="discount-flash-badge">💊 {discountPct}% OFF</span>
          <span className="discount-flash-text">Order medicines online & save big — discount applied automatically!</span>
          <span className="discount-flash-dot" />
          {/* <span className="discount-flash-badge">🔬 {discountPct}% OFF</span>
          <span className="discount-flash-text">Book diagnostic tests at home — {discountPct}% off today!</span> */}
          <span className="discount-flash-dot" />
        </div>
    </div>
  </div>
)}


      <div className="root">
        <div className="hero1" >
         <AyujaBanner
            discountPct={discountPct}
            HEALTH_PACKAGES={HEALTH_PACKAGES}
            // HEALTH_CAMPS={HEALTH_CAMPS}
          />
          </div>

        {/* ── HERO ── */}
        <div className="hero">

          <div className="hero-d1" /><div className="hero-d2" />
          <div className="hero-inner">
            <div className="hero-left">
              <span className="hero-eyebrow">🌿 Ayuja Life Services</span>
              <h1 className="hero-heading">Your Health,<br /><span className="hero-heading-accent">Our Priority</span></h1>
              <p className="hero-desc">Trusted, compassionate healthcare delivered right to your doorstep — anytime, anywhere.</p>

              <HeroOfferHighlight
      discountPct={discountPct}
      HEALTH_PACKAGES={HEALTH_PACKAGES}
      HEALTH_CAMPS={HEALTH_CAMPS}
      onPackageClick={setSelectedPackage}
      onCampClick={setSelectedCamp}
    />

              {/* <div className="stats-row">
                {STATS.map((s) => (
                  <div key={s.label} className="stat-item">
                    <span className="stat-icon">{s.icon}</span>
                    <span
                      className="stat-value"
                      style={{ cursor: s.label === "Camps Done" ? "pointer" : "default" }}
                      onClick={() => s.label === "Camps Done" && handleHeroClick()}
                    >
                      {s.value}
                    </span>
                    <span className="stat-label">{s.label}</span>
                  </div>
                ))}
              </div> */}
            </div>
 
            <div className="hero-right">

              <div className="hero-right-label">Available Services</div>
              {HERO_CARDS.map((card, i) => (
                <div key={i} className={`hero-visual-card ${card.badge === "Coming Soon" ? "hero-card-muted" : ""}`}
                  onClick={() => card.badge !== "Coming Soon" && navigate(card.path)}
                  style={{ cursor: card.badge === "Coming Soon" ? "not-allowed" : "pointer" }}>
                  <span className="hero-card-icon">{card.icon}</span>
                  <div className="hero-card-info">
                    <p className="hero-card-label">{card.label}</p>
                    <p className="hero-card-title">{card.title}</p>
                    <p className="hero-card-sub">{card.sub}</p>
                  </div>
                  <span className={`hero-card-badge ${card.badge === "Coming Soon" ? "badge-muted" : ""}`}>{card.badge}</span>
                </div>
              ))}
              <div className="hero-trust-row">
                {["✅ NABL Certified", "🔒 100% Safe", "⚡ Fast Results"].map((t) => (
                  <span key={t} className="hero-trust-badge">{t}</span>
                ))}
              </div>
            </div>
          </div>
        </div>


        {!contentLoading && (HEALTH_CAMPS.length > 0 || HEALTH_PACKAGES.length > 0 || discountPct) && (
  <div style={{ maxWidth:1300, margin:"0 auto", padding:"40px 32px 0" }}>
    <HeroSliderBanner
      camps={HEALTH_CAMPS}
      packages={HEALTH_PACKAGES}
      discountPct={discountPct}
      onCampClick={setSelectedCamp}
      onPackageClick={setSelectedPackage}
    />
  </div>
)}




{!contentLoading && HEALTH_PACKAGES.length > 0 && (
  <div className="section packages-section">
    <div className="section-header">
      <div>
        <h2 className="section-title">🏥 Health Packages</h2>
        <p className="section-sub">Curated diagnostic bundles — comprehensive care at best value</p>
      </div>
      <div style={{ display:"flex", alignItems:"center", gap:12, flexWrap:"wrap" }}>
        <span className="packages-pill">✨ {HEALTH_PACKAGES.length} Packages Available</span>
        <div className="scroll-btns">
          <button className="scroll-btn" style={{ opacity: pkgCanL ? 1 : 0.3 }} onClick={() => scrollPkg(-1)}>‹</button>
          <button className="scroll-btn" style={{ opacity: pkgCanR ? 1 : 0.3 }} onClick={() => scrollPkg(1)}>›</button>
        </div>
      </div>
    </div>

    {/* Filter pills — scroll to card by index */}
    <div className="pkg-filters">
      {[...HEALTH_PACKAGES].reverse().map((pkg, i) => (
        <button
          key={pkg.id}
          className="pkg-filter-btn"
          style={{ borderColor: pkg.badgeColor, color: pkg.badgeColor }}
          onClick={() => {
            const el = pkgRef.current;
            if (!el) return;
            const cardWidth = el.scrollWidth / HEALTH_PACKAGES.length;
            el.scrollTo({ left: i * cardWidth, behavior: "smooth" });
          }}
        >
          {pkg.icon} {pkg.tier}
        </button>
      ))}
    </div>

    {/* Horizontal scroll — newest first, mouse drag enabled */}
    <div style={{ overflow: "hidden", borderRadius: 16 }}>
      <div
        className="camp-scroll"
        ref={pkgRef}
        onScroll={(e) => {
          const el = e.currentTarget;
          setPkgCanL(el.scrollLeft > 0);
          setPkgCanR(el.scrollLeft < el.scrollWidth - el.clientWidth - 10);
        }}
        onMouseDown={(e) => {
          pkgRef.current._isDragging = false;
          pkgRef.current._dragStartX = e.clientX;
          pkgRef.current._dragScrollLeft = pkgRef.current.scrollLeft;
          pkgRef.current._mouseDown = true;
        }}
        onMouseMove={(e) => {
          if (!pkgRef.current._mouseDown) return;
          const dx = e.clientX - pkgRef.current._dragStartX;
          if (Math.abs(dx) > 4) pkgRef.current._isDragging = true;
          pkgRef.current.scrollLeft = pkgRef.current._dragScrollLeft - dx;
        }}
        onMouseUp={() => { pkgRef.current._mouseDown = false; }}
        onMouseLeave={() => { pkgRef.current._mouseDown = false; }}
      >
        {[...HEALTH_PACKAGES].reverse().map((pkg) => (
          <div
            key={pkg.id}
            style={{ flexShrink:0, width:"clamp(300px,30vw,360px)", scrollSnapAlign:"start" }}
          >
            <PackageCard
              pkg={pkg}
              onClick={(p) => {
                if (!pkgRef.current?._isDragging) setSelectedPackage(p);
              }}
            />
          </div>
        ))}
      </div>
    </div>

    {/* Mobile: single column, newest first */}
    <div className="camp-grid-mobile" style={{ gridTemplateColumns:"1fr" }}>
      {[...HEALTH_PACKAGES].reverse().map((pkg) => (
        <PackageCard key={pkg.id} pkg={pkg} onClick={setSelectedPackage} />
      ))}
    </div>
  </div>
)}




      {/* ── CAMPS ── */}
      {!contentLoading && HEALTH_CAMPS.length > 0 && (
        <div className="section" ref={campsSectionRef}>
          <div className="section-header">
            <div>
              <h2 className="section-title">🏕️ Health Camps by Ayuja</h2>
              <p className="section-sub">Free & affordable community health drives near you</p>
            </div>
            <div className="scroll-btns">
              <button className="scroll-btn" style={{ opacity: canL ? 1 : 0.3 }} onClick={() => scroll(-1)}>‹</button>
              <button className="scroll-btn" style={{ opacity: canR ? 1 : 0.3 }} onClick={() => scroll(1)}>›</button>
            </div>
          </div>
          {/* <div className="camp-scroll-outer"> */}
            <div className="camp-scroll" ref={campRef}
              onScroll={(e) => { const el = e.currentTarget; setCanL(el.scrollLeft > 0); setCanR(el.scrollLeft < el.scrollWidth - el.clientWidth - 10); }}>
              {HEALTH_CAMPS.map((c) => (
                <div key={c.id} className="camp-item"><CampCard camp={c} onClick={setSelectedCamp} /></div>
              ))}
            {/* </div> */}
          </div>
          <div className="camp-grid-mobile">
            {HEALTH_CAMPS.map((c) => <CampCard key={c.id} camp={c} onClick={setSelectedCamp} />)}
          </div>
        </div>
      )}







        {/* ── SERVICES ── */}
        <div className="section services-section">
          <div className="section-header">
            <div>
              <h2 className="section-title">🏥 Our Services</h2>
              <p className="section-sub">Comprehensive home healthcare — book in minutes</p>
            </div>
            <span className="active-pill">✅ 3 Services Active</span>
          </div>
          <div className="services-grid">
            {sorted.map((s) => (
              <ServiceCard key={s.id} service={s} isActive={ACTIVE_IDS.includes(s.id)}
                onNavigate={(screen) => navigate(screen)} priceLabel={getPriceLabel(s.title)} />
            ))}
          </div>
        </div>

        {/* ── WHY AYUJA ── */}
        <div className="why-section">
          <div className="why-inner">
            <h2 className="why-title">Why Choose Ayuja?</h2>
            <p className="why-sub">Technology meets compassion for exceptional healthcare</p>
            <div className="why-grid">
              {[
                { icon:"🏠", title:"Home Collection", desc:"We come to you — no travel, no queues, no stress." },
                { icon:"⚡", title:"Fast Turnaround", desc:"Results delivered quickly to your inbox or WhatsApp." },
                { icon:"🔬", title:"Certified Labs", desc:"All tests processed at NABL-accredited laboratories." },
                { icon:"💬", title:"24/7 Support", desc:"Our care team is always just a call or message away." },
              ].map((w) => (
                <div key={w.title} className="why-card">
                  <span className="why-icon">{w.icon}</span>
                  <h3 className="why-card-title">{w.title}</h3>
                  <p className="why-card-desc">{w.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>



        {selectedCamp && <CampModal camp={selectedCamp} onClose={() => setSelectedCamp(null)} />}
        {selectedPackage && (
          <PackageModal pkg={selectedPackage} onClose={() => setSelectedPackage(null)} onBook={handleBookPackage} />
        )}
        {bookingPackage && <BookingModal pkg={bookingPackage} onClose={() => setBookingPackage(null)} />}
      </div>

      <Footer />
      <FloatingSupportWidget phone="+917661889977" /> 
    </>
  );
};

export default ServiceSelectionScreen;

// ─── CSS ───────────────────────────────────────────────────────────────────────
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;600;700;800;900&family=DM+Sans:wght@400;500;600&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .root { min-height:100vh; background:#EEF4F5; font-family:'DM Sans',sans-serif; color:#0F172A;padding-top: 40px;  }
    .hero1 { padding:52px 32px 56px; position:relative; overflow:hidden; }

  .hero { background:linear-gradient(135deg,#003D45 0%,#006D77 55%,#008B98 100%); padding:52px 32px 56px; position:relative; overflow:hidden; }
  .hero-d1 { position:absolute; top:-180px; right:-80px; width:380px; height:380px; border-radius:50%; background:rgba(255,255,255,0.05); pointer-events:none; }
  .hero-d2 { position:absolute; bottom:-60px; left:5%; width:260px; height:260px; border-radius:50%; background:rgba(255,255,255,0.04); pointer-events:none; }
  .hero-inner { max-width:1300px; margin:0 auto; position:relative; z-index:1; display:grid; grid-template-columns:1fr 1fr; gap:52px; align-items:center; }
  .hero-eyebrow { font-size:12px; font-weight:600; color:rgba(255,255,255,0.7); letter-spacing:1.2px; text-transform:uppercase; background:rgba(255,255,255,0.1); padding:6px 14px; border-radius:50px; border:1px solid rgba(255,255,255,0.2); margin-bottom:18px; display:inline-block; }
  .hero-heading { font-family:'Sora',sans-serif; font-size:clamp(2rem,3.5vw,3rem); font-weight:900; color:#FFFFFF; line-height:1.18; margin-bottom:14px; }
  .hero-heading-accent { color:#80ED99; }
  .hero-desc { font-size:15px; color:rgba(255,255,255,0.72); line-height:1.78; max-width:440px; margin-bottom:28px; }
  .stats-row { display:flex; gap:12px; flex-wrap:wrap; }
  .stat-item { display:flex; flex-direction:column; gap:2px; background:rgba(255,255,255,0.09); border-radius:14px; padding:10px 14px; border:1px solid rgba(255,255,255,0.13); min-width:80px; }
  .stat-icon { font-size:16px; margin-bottom:3px; }
  .stat-value { font-family:'Sora',sans-serif; font-size:18px; font-weight:900; color:#FFFFFF; line-height:1; }
  .stat-label { font-size:10px; color:rgba(255,255,255,0.58); font-weight:500; line-height:1.4; }
  .hero-right { display:flex; flex-direction:column; gap:14px; }
  .hero-right-label { font-size:12px; font-weight:700; color:rgba(255,255,255,0.6); text-transform:uppercase; letter-spacing:1.2px; margin-bottom:2px; }
  .hero-visual-card { background:rgba(255,255,255,0.1); backdrop-filter:blur(14px); border:1px solid rgba(255,255,255,0.2); border-radius:18px; padding:16px 20px; display:flex; align-items:center; gap:14px; transition:all 0.3s; }
  .hero-visual-card:hover { background:rgba(255,255,255,0.18); transform:translateX(5px); }
  .hero-card-muted { opacity:0.55; }
  .hero-card-muted:hover { transform:none; background:rgba(255,255,255,0.1); }
  .hero-card-icon { font-size:32px; flex-shrink:0; }
  .hero-card-info { flex:1; min-width:0; }
  .hero-card-label { font-size:10px; font-weight:600; color:rgba(255,255,255,0.55); text-transform:uppercase; letter-spacing:1px; margin-bottom:3px; }
  .hero-card-title { font-family:'Sora',sans-serif; font-size:15px; font-weight:700; color:#FFFFFF; margin-bottom:2px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .hero-card-sub { font-size:12px; color:rgba(255,255,255,0.6); }
  .hero-card-badge { flex-shrink:0; background:#80ED99; color:#003D45; font-size:11px; font-weight:800; padding:5px 12px; border-radius:20px; white-space:nowrap; }
  .badge-muted { background:rgba(255,255,255,0.15); color:rgba(255,255,255,0.6); }
  .hero-trust-row { display:flex; gap:8px; flex-wrap:wrap; margin-top:4px; }
  .hero-trust-badge { font-size:11px; font-weight:600; color:rgba(255,255,255,0.75); background:rgba(255,255,255,0.1); padding:5px 12px; border-radius:20px; border:1px solid rgba(255,255,255,0.2); }
  .section { max-width:1300px; margin:0 auto; padding:68px 32px 0; }
  .services-section { padding-bottom:68px; }
  .packages-section { padding-bottom:52px; }
  .section-header { display:flex; justify-content:space-between; align-items:flex-start; margin-bottom:28px; flex-wrap:wrap; gap:16px; }
  .section-title { font-family:'Sora',sans-serif; font-size:clamp(1.4rem,3vw,2rem); font-weight:800; color:#0F172A; margin-bottom:6px; }
  .section-sub { font-size:15px; color:#64748B; }
  .scroll-btns { display:flex; gap:10px; align-items:center; }
  .scroll-btn { width:44px; height:44px; border-radius:50%; border:1.5px solid #CBD5E1; background:#FFFFFF; cursor:pointer; font-size:22px; color:#006D77; display:flex; align-items:center; justify-content:center; transition:all 0.2s; box-shadow:0 2px 10px rgba(0,0,0,0.08); }
  .scroll-btn:hover { background:#006D77; color:#fff; border-color:#006D77; }
  .packages-pill { background:#E0F7F8; color:#006D77; font-size:13px; font-weight:700; padding:8px 18px; border-radius:50px; border:1.5px solid #B2E0E4; white-space:nowrap; align-self:flex-start; }
  .pkg-filters { display:flex; gap:10px; flex-wrap:wrap; margin-bottom:24px; }
  .pkg-filter-btn { background:transparent; border:1.5px solid; border-radius:50px; padding:6px 16px; font-size:12px; font-weight:700; cursor:pointer; transition:all 0.2s; font-family:'DM Sans',sans-serif; }
  .pkg-filter-btn:hover { opacity:0.75; transform:translateY(-1px); }
  .packages-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(340px,1fr)); gap:24px; }
  .camp-scroll-outer {overflow: visible;
    -webkit-mask-image: linear-gradient(to right, transparent 0%, black 2%, black 98%, transparent 100%);
    mask-image: linear-gradient(to right, transparent 0%, black 2%, black 98%, transparent 100%);
  }
  .camp-scroll {display: flex;gap: 22px;overflow-x: scroll;padding-bottom: 16px;scroll-snap-type: x mandatory;-webkit-overflow-scrolling: touch;cursor: grab;user-select: none;scrollbar-width: none;align-items: stretch;}
  .camp-scroll::-webkit-scrollbar { display: none; } user-select: none; }
  .camp-scroll:active { cursor: grabbing; }
  .camp-scroll.is-dragging { scroll-snap-type: none; }
  .camp-scroll::-webkit-scrollbar { height:4px; }
  .camp-scroll::-webkit-scrollbar-thumb { background:#006D77; border-radius:4px; }
  .camp-item { flex-shrink:0; width:clamp(280px,26vw,320px); scroll-snap-align:start;  display: flex;   }
  .camp-item > * {height: 100%;display: flex;flex-direction: column;}
  .camp-grid-mobile { display:none; }
  .services-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(300px,1fr)); gap:22px; }
  .active-pill { background:#ECFDF5; color:#059669; font-size:13px; font-weight:700; padding:8px 18px; border-radius:50px; border:1.5px solid #A7F3D0; white-space:nowrap; align-self:flex-start; }
  .why-section { background:linear-gradient(135deg,#006D77 0%,#003D45 100%); margin-top:1px; padding:32px 12px; }
  .why-inner { max-width:1300px; margin:0 auto; }
  .why-title { font-family:'Sora',sans-serif; font-size:clamp(1.6rem,4vw,2.4rem); font-weight:900; color:#FFFFFF; text-align:center; margin-bottom:12px; }
  .why-sub { font-size:16px; color:rgba(255,255,255,0.68); text-align:center; margin-bottom:48px; max-width:500px; margin-inline:auto; line-height:1.7; }
  .why-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(240px,1fr)); gap:30px; justify-content:center; text-align:center; }
  .why-card { background:rgba(255,255,255,0.1); border-radius:22px; padding:30px 24px; border:1px solid rgba(255,255,255,0.15); backdrop-filter:blur(10px); transition:transform 0.25s; }
  .why-card:hover { transform:translateY(-5px); }
  .why-icon { font-size:36px; display:block; margin-bottom:16px; }
  .why-card-title { font-family:'Sora',sans-serif; font-size:18px; font-weight:700; color:#FFFFFF; margin-bottom:10px; }
  .why-card-desc { font-size:14px; color:rgba(255,255,255,0.68); line-height:1.75; }
  @media (max-width:960px) {
    .hero-inner { grid-template-columns:1fr; gap:36px; }
    .hero-right { max-width:480px; }
    .hero-heading { font-size:clamp(1.9rem,5vw,2.6rem); }
    .packages-grid { grid-template-columns:repeat(auto-fill,minmax(280px,1fr)); }
  }
  @media (max-width:768px) {
    .camp-scroll-outer { display:none; }
    .camp-grid-mobile { display:grid !important; grid-template-columns:1fr 1fr; gap:16px; }
    .scroll-btns { display:none; }
    .hero { padding:44px 20px 48px; }
    .section { padding:52px 20px 0; }
    .packages-section { padding-bottom:36px; }
    .stats-row { gap:8px; }
    .packages-grid { grid-template-columns:1fr; }
  }
  @media (max-width:520px) {
    .camp-grid-mobile { grid-template-columns:1fr !important; }
    .services-grid { grid-template-columns:1fr; }
    .why-grid { grid-template-columns:1fr; }
    .hero-trust-row { gap:6px; }
    .pkg-filters { gap:6px; }
  }
.camp-banner-section {border-radius: 22px;padding: 40px 48px 28px;position: relative;overflow: hidden;cursor: pointer;box-shadow: 0 16px 48px rgba(0,109,119,0.35);transition: transform 0.3s ease, box-shadow 0.3s ease;will-change: transform;cursor: grab;}
.camp-banner-section:hover {transform: translateY(-3px);box-shadow: 0 24px 64px rgba(0,109,119,0.45); cursor: grabbing;}

.camp-banner-fade {animation: bannerFadeIn 0.5s ease forwards;}
@keyframes bannerFadeIn {from { opacity: 0; transform: translateY(8px); } to   { opacity: 1; transform: translateY(0);   }}
.camp-banner-deco1 {position: absolute; top: -80px; right: 320px;width: 300px; height: 300px; border-radius: 50%;background: rgba(255,255,255,0.06); pointer-events: none;}
.camp-banner-deco2 {position: absolute; bottom: -60px; left: -40px;width: 200px; height: 200px; border-radius: 50%;background: rgba(255,255,255,0.05); pointer-events: none;}
.camp-banner-inner {display: flex; justify-content: space-between;align-items: center; gap: 24px; position: relative; z-index: 1;}
.camp-banner-left { flex: 1; min-width: 0; }
.camp-banner-badge {display: inline-block;background: rgba(255,255,255,0.18); border: 1px solid rgba(255,255,255,0.3);color: #FFFFFF; font-size: 11px; font-weight: 800;padding: 4px 14px; border-radius: 20px;margin-bottom: 14px; letter-spacing: 0.8px; text-transform: uppercase;}
.camp-banner-title {font-family: 'Sora', sans-serif;font-size: clamp(1.5rem, 2.8vw, 2.1rem);font-weight: 900; color: #FFFFFF;margin-bottom: 4px; line-height: 1.25;}
.camp-banner-sub {font-size: 14px; color: rgba(255,255,255,0.72);margin-bottom: 22px; line-height: 1.6; max-width: 520px;}
.camp-banner-stats {display: flex; align-items: center;gap: 18px; flex-wrap: wrap; margin-bottom: 22px;}
.camp-banner-stat-box {display: flex; align-items: center; gap: 10px;background: rgba(0,0,0,0.2); border-radius: 12px;padding: 10px 16px; border: 1px solid rgba(255,255,255,0.15);}
.camp-banner-stat-icon { font-size: 22px; }
.camp-banner-stat-num {font-family: 'Sora', sans-serif; font-size: 22px;font-weight: 900; color: #FFFFFF; display: block; line-height: 1;}
.camp-banner-stat-label {font-size: 9px; font-weight: 700; color: rgba(255,255,255,0.6);text-transform: uppercase; letter-spacing: 0.5px; line-height: 1.4;}
.camp-banner-divider {width: 1.5px; height: 44px;background: rgba(255,255,255,0.25); flex-shrink: 0;}
.camp-banner-date-block { display: flex; flex-direction: column; gap: 3px; }
.camp-banner-off-badge {background: #10B981; color: #fff; font-size: 10px; font-weight: 800;padding: 2px 8px; border-radius: 6px; display: inline-block; width: fit-content;}
.camp-banner-date-val {font-family: 'Sora', sans-serif; font-size: 18px;font-weight: 900; color: #FFFFFF;}
.camp-banner-phone { font-size: 12px; color: rgba(255,255,255,0.65); }
.camp-banner-btn {background: #FFFFFF; color: #006D77; border: none;font-size: 15px; font-weight: 900; padding: 14px 28px;border-radius: 50px; cursor: pointer; letter-spacing: 0.3px;font-family: 'Sora', sans-serif; transition: all 0.25s;white-space: nowrap; box-shadow: 0 4px 16px rgba(0,0,0,0.18);}
.camp-banner-btn:hover { background: #FFD166; color: #003D45; transform: translateX(4px); }
.camp-banner-trust-row { display: flex; gap: 20px; flex-wrap: wrap; }
.camp-banner-trust-item { display: flex; align-items: center; gap: 8px; }
.camp-banner-trust-icon-wrap {width: 36px; height: 36px; border-radius: 10px;background: rgba(255,255,255,0.15); border: 1px solid rgba(255,255,255,0.25);display: flex; align-items: center; justify-content: center;color: #FFD166; flex-shrink: 0; transition: background 0.2s ease;}
.camp-banner-trust-item:hover .camp-banner-trust-icon-wrap {background: rgba(255,255,255,0.25);}
.camp-banner-trust-bold { font-size: 12px; font-weight: 700; color: #FFD166; }
.camp-banner-trust-sub  { font-size: 11px; color: rgba(255,255,255,0.65); }
.camp-banner-right {
  flex-shrink: 0; width: 320px;
  display: flex; align-items: flex-end; justify-content: center;
}
.camp-banner-img {
  width: 100%; max-height: 620px;
  object-fit: contain; object-position: bottom;
  filter: drop-shadow(0 8px 24px rgba(0,0,0,0.3));
  transition: transform 0.5s ease;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}
.camp-banner-section:hover .camp-banner-img {transform: scale(1.04) translateY(-4px);}
.camp-banner-dots {display: flex; gap: 6px; justify-content: center;margin-top: 20px; position: relative; z-index: 1;}
.camp-banner-dot {width: 6px; height: 6px; border-radius: 50%;background: rgba(255,255,255,0.3); transition: all 0.3s ease;cursor: pointer;}
.camp-banner-dot-active {background: #FFD166; width: 22px; border-radius: 3px;box-shadow: 0 0 8px rgba(255,209,102,0.6);}
.camp-scroll {display: flex; gap: 22px; overflow-x: auto;padding-bottom: 16px; scroll-snap-type: x mandatory;-webkit-overflow-scrolling: touch;cursor: grab;user-select: none;}
.camp-scroll:active { cursor: grabbing; }
.camp-scroll.is-dragging { scroll-snap-type: none; }
.camp-scroll::-webkit-scrollbar { height: 4px; }
.camp-scroll::-webkit-scrollbar-thumb { background: #006D77; border-radius: 4px; }

@media (max-width: 900px) {
  .camp-banner-right { width: 420px; }
  .camp-banner-img   { max-height: 640px; }
}
@media (max-width: 680px) {
  .camp-banner-section { padding: 28px 24px 22px; }
  .camp-banner-inner   { flex-direction: column-reverse; }
  .camp-banner-right   { width: 160px; align-self: flex-end; }
  .camp-banner-img     { max-height: 160px; }
  .camp-banner-trust-row { gap: 10px; }
  .camp-banner-stats     { gap: 10px; }
}

  .cfc-wrap {position: relative;border-radius: 20px;padding: 0;cursor: pointer;overflow: hidden;background: linear-gradient(135deg, rgba(0,61,69,0.95) 0%, rgba(0,80,90,0.9) 50%, rgba(0,109,119,0.85) 100%);border: 1px solid rgba(128,237,153,0.25);box-shadow: 0 8px 32px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.08);transition: opacity 0.5s ease, transform 0.5s ease, box-shadow 0.3s ease;}
  .cfc-wrap:hover {box-shadow: 0 16px 48px rgba(0,0,0,0.4), 0 0 0 1px rgba(128,237,153,0.5), inset 0 1px 0 rgba(255,255,255,0.12);transform: translateY(-3px) !important;}
  .cfc-in  { opacity: 1; transform: translateY(0) scale(1); }
  .cfc-out { opacity: 0; transform: translateY(-10px) scale(0.97); }

  /* Animated corner glow */
  .cfc-glow {position: absolute;top: -40px; right: -40px; width: 140px; height: 140px;border-radius: 50%;background: radial-gradient(circle, rgba(128,237,153,0.18) 0%, transparent 70%);pointer-events: none; animation: cfc-glow-pulse 3s ease-in-out infinite;
  }
  @keyframes cfc-glow-pulse {
    0%, 100% { opacity: 0.6; transform: scale(1); }
    50% { opacity: 1; transform: scale(1.2); }
  }

  /* Top bar */
  .cfc-topbar {display: flex;align-items: center;justify-content: space-between;padding: 12px 16px 8px;gap: 8px;}
  .cfc-live-pill {display: flex;align-items: center;gap: 6px;background: rgba(128,237,153,0.15);border: 1px solid rgba(128,237,153,0.35);border-radius: 20px;padding: 3px 10px 3px 8px;font-size: 9px;font-weight: 900;color: #80ED99;letter-spacing: 1.5px;text-transform: uppercase;}
  .cfc-live-dot {width: 7px; height: 7px;border-radius: 50%;background: #80ED99;box-shadow: 0 0 6px #80ED99;animation: cfc-blink 1.4s ease-in-out infinite;flex-shrink: 0;}
  @keyframes cfc-blink {
    0%, 100% { opacity: 1; box-shadow: 0 0 6px #80ED99; }
    50% { opacity: 0.3; box-shadow: none; }
  }
  .cfc-nav {display: flex;gap: 5px;align-items: center;flex: 1;justify-content: center;}
  .cfc-navdot {width: 5px; height: 5px;border-radius: 50%;background: rgba(255,255,255,0.2);transition: all 0.4s ease;}
  .cfc-navdot-active {background: #80ED99;width: 18px;border-radius: 3px;box-shadow: 0 0 8px rgba(128,237,153,0.6);}
  .cfc-counter {font-size: 10px;font-weight: 700;color: rgba(255,255,255,0.35);letter-spacing: 0.5px;white-space: nowrap; }
  /* Progress bar */
  .cfc-progress-track {height: 2px;background: rgba(255,255,255,0.08);margin: 0 16px;border-radius: 2px;overflow: hidden;}
  .cfc-progress-fill {height: 100%;background: linear-gradient(90deg, #80ED99, #00C9B1);border-radius: 2px;transition: width 0.1s linear;box-shadow: 0 0 6px rgba(128,237,153,0.5);}

  /* Body */
  .cfc-body {display: flex;align-items: center;gap: 14px;padding: 14px 16px 10px;}
  .cfc-icon-wrap { position: relative; flex-shrink: 0; width: 52px; height: 52px; display: flex; align-items: center; justify-content: center;}
  .cfc-icon {font-size: 30px;position: relative;z-index: 1;filter: drop-shadow(0 2px 8px rgba(0,0,0,0.3));}
  .cfc-icon-ring {position: absolute;inset: 0;border-radius: 14px;background: rgba(128,237,153,0.12);border: 1px solid rgba(128,237,153,0.25);animation: cfc-ring-pulse 3s ease-in-out infinite;}
  @keyframes cfc-ring-pulse {0%, 100% { transform: scale(1); opacity: 1; }50% { transform: scale(1.08); opacity: 0.7; }}
  .cfc-content { flex: 1; min-width: 0; }
  .cfc-title {font-family: 'Sora', sans-serif;font-size: 14px;font-weight: 800;color: #FFFFFF;margin-bottom: 4px;line-height: 1.3;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
  .cfc-sub {font-size: 11px;color: rgba(255,255,255,0.55);line-height: 1.5;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden; }

  /* Date badges */
  .cfc-dates {display: flex;gap: 6px;padding: 0 16px 10px;flex-wrap: wrap;}
  .cfc-date-badge {font-size: 10px;font-weight: 800;color: #80ED99;background: rgba(128,237,153,0.12);border: 1px solid rgba(128,237,153,0.3);padding: 3px 10px;border-radius: 8px;letter-spacing: 0.3px;}
  /* Test chips */
  .cfc-chips {display: flex;gap: 5px;padding: 0 16px 12px;flex-wrap: wrap;}
  .cfc-chip {font-size: 10px;font-weight: 600;color: rgba(255,255,255,0.7);background: rgba(255,255,255,0.07);border: 1px solid rgba(255,255,255,0.12);padding: 3px 9px;border-radius: 20px;white-space: nowrap;transition: all 0.2s;}
  .cfc-chip-more {color: #80ED99 !important;border-color: rgba(128,237,153,0.3) !important;background: rgba(128,237,153,0.1) !important;}
  /* Footer */
  .cfc-footer {display: flex;align-items: center;justify-content: space-between;padding: 10px 16px 12px;border-top: 1px solid rgba(255,255,255,0.07);background: rgba(0,0,0,0.15);}
  .cfc-cta-text {font-size: 11px;font-weight: 700;color: rgba(255,255,255,0.55);letter-spacing: 0.2px;}
  .cfc-arrow {width: 26px; height: 26px;border-radius: 50%;background: rgba(128,237,153,0.15);border: 1px solid rgba(128,237,153,0.35);display: flex; align-items: center; justify-content: center;font-size: 13px;color: #80ED99;font-weight: 700;transition: all 0.25s;flex-shrink: 0;}
  .cfc-wrap:hover .cfc-arrow {background: #80ED99;color: #003D45;transform: translateX(3px);box-shadow: 0 0 12px rgba(128,237,153,0.5); }
  .cfc-wrap:hover .cfc-chip {background: rgba(255,255,255,0.1);}

.camp-banner-trust-icon-wrap {
  width: 36px; height: 36px;
  border-radius: 10px;
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.25);
  display: flex; align-items: center; justify-content: center;
  color: #FFD166;
  flex-shrink: 0;
  transition: background 0.2s ease;
}
.camp-banner-trust-item:hover .camp-banner-trust-icon-wrap {
  background: rgba(255,255,255,0.25);
}



/* ── Discount Flash Banner ── */
.discount-flash-bar {
  background: linear-gradient(90deg, #006D77 0%, #008B98 50%, #006D77 100%);
  background-size: 200% auto;
  animation: flashSlide 3s linear infinite;
  padding: 15px 20px;
  text-align: center;
  position: fixed;       
  top: 10;
  left: 0;
  right: 0;               
  z-index: 9999;        
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;     
  overflow: hidden;
}

@keyframes flashSlide {
  0%   { background-position: 0% center; }
  100% { background-position: 200% center; }
}

.discount-flash-text {
  font-family: 'Sora', sans-serif;
  font-size: clamp(16px, 2.2vw, 15px);
  font-weight: 800;
  color: #FFFFFF;
  letter-spacing: 0.4px;
  white-space: nowrap;
}

.discount-flash-badge {
  background: #FFD166;
  color: #003D45;
  font-size: clamp(19px, 2vw, 14px);
  font-weight: 900;
  padding: 4px 14px;
  border-radius: 20px;
  white-space: nowrap;
  animation: pulse 1.8s ease-in-out infinite;
  flex-shrink: 0;
}

@keyframes pulse {
  0%, 100% { transform: scale(1);    box-shadow: 0 0 0 0 rgba(255,209,102,0.5); }
  50%       { transform: scale(1.06); box-shadow: 0 0 0 6px rgba(255,209,102,0);  }
}

.discount-flash-marquee {
  display: flex;
  align-items: center;
  gap: 40px;
  animation: marquee 18s linear infinite;
  padding: 0 28px;  
}

@keyframes marquee {
  from { transform: translateX(30%); }
  to   { transform: translateX(-100%); }
}

.discount-flash-dot {
  width: 5px; height: 5px;
  border-radius: 50%;
  background: rgba(255,255,255,0.4);
  flex-shrink: 0;
}

@media (max-width: 520px) {
  .discount-flash-bar { padding: 8px 12px; }
}

@keyframes seamless-scroll {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

`;










const HSB_CSS = `
/* ══ Root ══ */
.hsb-root {
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(0,0,0,0.45), 0 0 0 1px rgba(255,255,255,0.07);
  position: relative;
  user-select: none;
}

/* ══ Scrollable track ══ */
.hsb-track {
  display: flex;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  cursor: grab;
}
.hsb-track:active { cursor: grabbing; }
.hsb-track::-webkit-scrollbar { display: none; }

/* ══ Each slide ══ */
.hsb-slide {
  flex-shrink: 0;
  width: 100%;
  min-height: 380px;
  scroll-snap-align: start;
  padding: 44px 52px 28px;
  position: relative;
  overflow: hidden;
  transition: background 0.5s ease;
}

/* ── BG layers ── */
.hsb-grid {
  position:absolute; inset:0; pointer-events:none;
  background-image:
    linear-gradient(rgba(255,255,255,0.028) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.028) 1px, transparent 1px);
  background-size: 44px 44px;
}
.hsb-orb1 {
  position:absolute; top:-100px; right:220px;
  width:360px; height:360px; border-radius:50%;
  filter:blur(90px); pointer-events:none; opacity:0.55;
  animation: hsb-orb 5s ease-in-out infinite;
}
.hsb-orb2 {
  position:absolute; bottom:-80px; left:-60px;
  width:240px; height:240px; border-radius:50%;
  filter:blur(70px); pointer-events:none; opacity:0.4;
  animation: hsb-orb 7s ease-in-out infinite reverse;
}
@keyframes hsb-orb {
  0%,100%{ transform:scale(1);   opacity:0.5; }
  50%    { transform:scale(1.25); opacity:0.85; }
}
.hsb-sweep {
  position:absolute; top:0; left:-100%; width:45%; height:100%;
  background:linear-gradient(90deg,transparent,rgba(255,255,255,0.045),transparent);
  animation:hsb-sweep 5s ease-in-out infinite; pointer-events:none;
}
@keyframes hsb-sweep { 0%{left:-100%} 65%{left:150%} 100%{left:150%} }

.hsb-blob {
  position:absolute; border-radius:50%; pointer-events:none;
  animation:hsb-float 7s ease-in-out infinite;
}
.hsb-b1{width:100px;height:100px;top:8%;  left:12%; animation-delay:0s;  }
.hsb-b2{width:70px; height:70px; top:65%; left:8%;  animation-delay:1s;  }
.hsb-b3{width:55px; height:55px; top:15%; right:28%;animation-delay:2s;  }
.hsb-b4{width:80px; height:80px; bottom:8%;right:12%;animation-delay:0.5s;}
.hsb-b5{width:45px; height:45px; top:45%; left:38%; animation-delay:1.5s;}
.hsb-b6{width:60px; height:60px; top:30%; right:40%;animation-delay:2.5s;}
@keyframes hsb-float {
  0%,100%{ transform:translateY(0)   scale(1);   opacity:0.5; }
  50%    { transform:translateY(-22px) scale(1.1); opacity:0.9; }
}

/* ══ Content ══ */
.hsb-content {
  display:grid;
  grid-template-columns: 1fr 260px;
  gap:28px; align-items:center;
  position:relative; z-index:2;
  max-width:1200px; margin:0 auto;
}

/* ── Left ── */
.hsb-left { display:flex; flex-direction:column; gap:14px; }

.hsb-tag {
  display:inline-flex; align-items:center; gap:8px;
  border:1px solid; border-radius:50px;
  padding:5px 16px; font-size:11px; font-weight:800;
  text-transform:uppercase; letter-spacing:1px; width:fit-content;
}
.hsb-tag-dot {
  width:7px;height:7px;border-radius:50%;flex-shrink:0;
  animation:hsb-blink 1.3s ease-in-out infinite;
}
@keyframes hsb-blink{ 0%,100%{opacity:1;}50%{opacity:0.15;} }

.hsb-headline {
  font-family:'Sora',sans-serif;
  font-size:clamp(1.6rem,3vw,2.4rem);
  font-weight:900; color:#fff; line-height:1.15; margin:0;
}
.hsb-sub {
  font-size:15px; font-weight:600;
  color:rgba(255,255,255,0.68); margin:0;
}
.hsb-body {
  font-size:13px; color:rgba(255,255,255,0.52);
  line-height:1.75; margin:0; max-width:460px;
}

.hsb-pills { display:flex; gap:7px; flex-wrap:wrap; }
.hsb-pill {
  background:rgba(255,255,255,0.07); border:1px solid;
  border-radius:20px; padding:5px 12px;
  font-size:11px; font-weight:600; white-space:nowrap;
  color:rgba(255,255,255,0.78);
}

.hsb-cta {
  display:inline-flex; align-items:center; gap:8px;
  border:none; border-radius:50px;
  padding:13px 28px;
  font-family:'Sora',sans-serif; font-size:13px; font-weight:900;
  cursor:pointer; width:fit-content;
  box-shadow:0 8px 24px rgba(0,0,0,0.3);
  transition:all 0.25s;
}
.hsb-cta:hover { filter:brightness(1.1); transform:translateY(-3px); box-shadow:0 14px 32px rgba(0,0,0,0.4); }

.hsb-slide-num {
  font-family:'Sora',sans-serif;
  font-size:11px; font-weight:700; letter-spacing:2px;
  margin-top:4px;
}

/* ── Right / Number card ── */
.hsb-right {
  display:flex; align-items:center; justify-content:center;
}
.hsb-numcard {
  position:relative; width:200px; height:200px;
  border-radius:28px;
  background:rgba(255,255,255,0.05);
  border:1px solid;
  backdrop-filter:blur(24px);
  display:flex; flex-direction:column;
  align-items:center; justify-content:center; gap:5px;
  overflow:hidden;
  transition:transform 0.3s;
}
.hsb-numcard:hover{ transform:scale(1.05) rotate(1.5deg); }

.hsb-ncglow {
  position:absolute; top:-50px; left:-50px;
  width:220px; height:220px; border-radius:50%;
  filter:blur(55px); opacity:0.5; pointer-events:none;
  animation:hsb-orb 3s ease-in-out infinite;
}

.hsb-ring {
  position:absolute; border-radius:50%; border:1.5px solid; pointer-events:none;
}
.hsb-ra{ width:170px;height:170px; animation:hsb-spin 10s linear infinite; }
.hsb-rb{ width:210px;height:210px; animation:hsb-spin 15s linear infinite reverse; }
.hsb-rc{ width:250px;height:250px; animation:hsb-spin 20s linear infinite; }
@keyframes hsb-spin{ to{transform:rotate(360deg);} }

/* Orbiting dots */
.hsb-orbit-dot {
  position:absolute; width:7px; height:7px; border-radius:50%;
  top:50%; left:50%;
  animation:hsb-orbit-spin 4s linear infinite;
  transform-origin:-80px 0;
}
@keyframes hsb-orbit-spin{
  from{ transform:translateX(-50%) rotate(0deg) translateX(80px) rotate(0deg); }
  to  { transform:translateX(-50%) rotate(360deg) translateX(80px) rotate(-360deg); }
}

.hsb-nc-icon-wrap {
  width:54px; height:54px; border-radius:15px;
  border:1.5px solid;
  display:flex; align-items:center; justify-content:center;
  position:relative; z-index:2;
  animation:hsb-icon-float 2.5s ease-in-out infinite;
}
@keyframes hsb-icon-float{
  0%,100%{transform:translateY(0);}
  50%{transform:translateY(-7px) scale(1.08);}
}
.hsb-nc-icon{ font-size:26px; filter:drop-shadow(0 3px 12px rgba(0,0,0,0.4)); }

.hsb-bignum {
  font-family:'Sora',sans-serif;
  font-size:clamp(1.5rem,3.5vw,2.2rem);
  font-weight:900; line-height:1;
  position:relative; z-index:2;
  animation:hsb-numglow 2s ease-in-out infinite;
}
@keyframes hsb-numglow{
  0%,100%{filter:brightness(1);}
  50%{filter:brightness(1.3) drop-shadow(0 0 14px currentColor);}
}
.hsb-mrp{
  font-size:11px; color:rgba(255,255,255,0.38);
  position:relative; z-index:2;
}
.hsb-biglabel{
  font-size:11px; font-weight:800;
  text-transform:uppercase; letter-spacing:1.2px;
  position:relative; z-index:2;
}

/* Pulse border */
.hsb-pulse-border {
  position:absolute; inset:0; border-radius:28px;
  border:2px solid; pointer-events:none;
  animation:hsb-pulse-b 2s ease-out infinite;
}
@keyframes hsb-pulse-b{
  0%  {opacity:1; transform:scale(1);}
  100%{opacity:0; transform:scale(1.08);}
}

/* ── Progress bar ── */
.hsb-pbar-track{
  height:3px; background:rgba(255,255,255,0.08);
  position:relative; z-index:3; margin-top:12px;
}
.hsb-pbar-fill{
  height:100%; width:0; border-radius:2px;
  animation:hsb-pbar 5s linear forwards;
}
@keyframes hsb-pbar{ from{width:0%} to{width:100%} }

/* ══ Nav ══ */
.hsb-nav {
  position:absolute; top:45%; transform:translateY(-50%);
  width:42px; height:42px; border-radius:50%;
  background:rgba(255,255,255,0.1);
  border:1.5px solid rgba(255,255,255,0.2);
  color:#fff; font-size:22px; font-weight:700;
  cursor:pointer; z-index:20;
  display:flex; align-items:center; justify-content:center;
  backdrop-filter:blur(12px);
  transition:all 0.22s;
}
.hsb-nav:hover{ background:var(--ac); color:#000; border-color:var(--ac); transform:translateY(-50%) scale(1.12); }
.hsb-nl{ left:14px; }
.hsb-nr{ right:14px; }

/* ══ Footer ══ */
.hsb-footer{
  display:flex; align-items:center; justify-content:space-between;
  padding:14px 20px; gap:12px;
  background:rgba(0,0,0,0.4);
  backdrop-filter:blur(16px);
  flex-wrap:wrap;
}

/* Thumbnail tabs */
.hsb-thumbs{ display:flex; gap:6px; flex:1; flex-wrap:wrap; }
.hsb-thumb{
  display:flex; align-items:center; gap:8px;
  background:rgba(255,255,255,0.05);
  border:1px solid rgba(255,255,255,0.1);
  color:rgba(255,255,255,0.5);
  padding:7px 12px; border-radius:14px;
  cursor:pointer; transition:all 0.25s;
  font-family:'DM Sans',sans-serif;
  position:relative; overflow:hidden;
}
.hsb-thumb:hover{ background:rgba(255,255,255,0.1); color:rgba(255,255,255,0.8); }
.hsb-thumb-on{ color:#fff !important; }
.hsb-thumb-icon{ font-size:18px; }
.hsb-thumb-text{ display:flex; flex-direction:column; align-items:flex-start; }
.hsb-thumb-type{ font-size:9px; font-weight:700; text-transform:uppercase; letter-spacing:0.8px; }
.hsb-thumb-name{ font-size:11px; font-weight:700; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:90px; }

/* Active underline bar */
.hsb-thumb-bar{
  position:absolute; bottom:0; left:0; right:0;
  height:2px; border-radius:2px;
  animation:hsb-bar-in 0.3s ease forwards;
}
@keyframes hsb-bar-in{ from{transform:scaleX(0)} to{transform:scaleX(1)} }

/* Dots */
.hsb-dots{ display:flex; gap:5px; align-items:center; }
.hsb-dot{
  width:7px; height:7px; border-radius:50%;
  background:rgba(255,255,255,0.2);
  border:none; cursor:pointer; transition:all 0.3s;
}
.hsb-dot-on{ border-radius:4px; height:7px; }

/* ══ Responsive ══ */
@media(max-width:900px){
  .hsb-slide{ padding:32px 28px 22px; min-height:300px; }
  .hsb-content{ grid-template-columns:1fr 180px; gap:16px; }
  .hsb-numcard{ width:160px; height:160px; }
  .hsb-ra{width:130px;height:130px;}
  .hsb-rb{width:170px;height:170px;}
  .hsb-rc{width:210px;height:210px;}
}
@media(max-width:640px){
  .hsb-slide{ padding:28px 20px 18px; min-height:auto; }
  .hsb-content{ grid-template-columns:1fr; }
  .hsb-right{ display:none; }
  .hsb-nl{ left:6px; } .hsb-nr{ right:6px; }
  .hsb-footer{ padding:10px 14px; }
  .hsb-thumb-name{ max-width:60px; }
  .hsb-nav{ width:34px; height:34px; font-size:18px; }
}
`;







const OFFER_HIGHLIGHT_CSS = `
  .ofl-wrap {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 14px 18px 14px 20px;
    border-radius: 16px;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.1);
    box-shadow: 0 0 32px var(--glow), inset 0 1px 0 rgba(255,255,255,0.08);
    backdrop-filter: blur(8px);
    position: relative;
    overflow: hidden;
    max-width: 460px;
    transition: box-shadow 0.3s;
  }
  .ofl-wrap:hover {
    box-shadow: 0 0 48px var(--glow), 0 4px 24px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.1);
  }

  /* fade + slide animations */
  .ofl-in {
    animation: oflIn 0.52s cubic-bezier(0.34,1.3,0.64,1) forwards;
  }
  .ofl-out {
    animation: oflOut 0.38s ease-in forwards;
  }
  @keyframes oflIn {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0);   }
  }
  @keyframes oflOut {
    from { opacity: 1; transform: translateY(0);    }
    to   { opacity: 0; transform: translateY(-6px); }
  }

  /* glowing left bar */
  .ofl-bar {
    position: absolute;
    left: 0; top: 0; bottom: 0;
    width: 3.5px;
    border-radius: 0 4px 4px 0;
    animation: oflBarPulse 2s ease-in-out infinite;
  }
  @keyframes oflBarPulse {
    0%,100% { opacity: 1; }
    50%      { opacity: 0.4; }
  }

  /* badge */
  .ofl-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    padding: 3px 12px;
    border-radius: 50px;
    width: fit-content;
  }
  .ofl-badge-dot {
    width: 6px; height: 6px;
    border-radius: 50%;
    flex-shrink: 0;
    animation: oflDotBlink 1.3s ease-in-out infinite;
  }
  @keyframes oflDotBlink {
    0%,100% { opacity: 1; }
    50%      { opacity: 0.2; }
  }

  /* main row */
  .ofl-main {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .ofl-icon {
    font-size: 28px;
    flex-shrink: 0;
    animation: oflIconFloat 2.2s ease-in-out infinite;
    filter: drop-shadow(0 2px 8px rgba(0,0,0,0.3));
  }
  @keyframes oflIconFloat {
    0%,100% { transform: translateY(0); }
    50%      { transform: translateY(-3px); }
  }
  .ofl-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
    min-width: 0;
  }
  .ofl-line1 {
    font-family: 'Sora', sans-serif;
    font-size: clamp(18px, 2.5vw, 24px);
    font-weight: 900;
    line-height: 1.15;
    letter-spacing: -0.3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    animation: oflGlow 2.5s ease-in-out infinite;
  }
  @keyframes oflGlow {
    0%,100% { filter: brightness(1); }
    50%      { filter: brightness(1.25) drop-shadow(0 0 8px currentColor); }
  }
  .ofl-line2 {
    font-size: 13px;
    font-weight: 600;
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* arrow */
  .ofl-arrow {
    width: 32px; height: 32px;
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    font-size: 15px; font-weight: 700;
    flex-shrink: 0;
    background: rgba(255,255,255,0.06);
    transition: transform 0.2s, background 0.2s;
  }
  .ofl-wrap:hover .ofl-arrow {
    transform: translateX(4px);
    background: rgba(255,255,255,0.12);
  }

  /* dots */
  .ofl-dots {
    display: flex;
    gap: 5px;
    align-items: center;
    padding-left: 2px;
  }
  .ofl-dot {
    height: 5px;
    border-radius: 3px;
    border: none;
    cursor: pointer;
    transition: all 0.35s;
    padding: 0;
  }

  @media (max-width: 640px) {
    .ofl-wrap { max-width: 100%; padding: 12px 14px 12px 16px; }
    .ofl-line1 { font-size: 18px; }
    .ofl-icon  { font-size: 24px; }
  }
`;












// ─── Style objects ─────────────────────────────────────────────────────────────
const PKC = {
  card: { backgroundColor:"#FFFFFF", borderRadius:22, overflow:"hidden", transition:"transform 0.3s ease, box-shadow 0.3s ease", display:"flex", flexDirection:"column", position:"relative" },
  gradientStrip: { padding:"24px 22px 20px", position:"relative", overflow:"hidden" },
  sd1: { position:"absolute", top:-40, right:-40, width:150, height:150, borderRadius:"50%", background:"rgba(255,255,255,0.1)" },
  sd2: { position:"absolute", bottom:-30, left:-20, width:100, height:100, borderRadius:"50%", background:"rgba(255,255,255,0.07)" },
  discountRibbon: { position:"absolute", top:14, right:0, background:"#10B981", color:"#fff", fontSize:11, fontWeight:800, padding:"4px 14px 4px 10px", borderRadius:"20px 0 0 20px", zIndex:2, letterSpacing:0.3 },
  topRow: { display:"flex", justifyContent:"flex-start", alignItems:"center", marginBottom:12, position:"relative", zIndex:1 },
  tierBadge: { fontSize:12, fontWeight:800, padding:"4px 12px", borderRadius:20 },
  name: { fontFamily:"'Sora',sans-serif", fontSize:16, fontWeight:800, color:"#FFFFFF", marginBottom:6, position:"relative", zIndex:1, lineHeight:1.35 },
  tagline: { fontSize:12, color:"rgba(255,255,255,0.72)", lineHeight:1.55, position:"relative", zIndex:1, marginBottom:12 },
  priceRow: { display:"flex", alignItems:"center", gap:8, position:"relative", zIndex:1, flexWrap:"wrap" },
  offerPrice: { fontFamily:"'Sora',sans-serif", fontSize:22, fontWeight:900 },
  strikeMRP: { fontSize:14, color:"rgba(255,255,255,0.5)", textDecoration:"line-through", fontWeight:600 },
  savingsChip: { background:"rgba(16,185,129,0.25)", border:"1px solid rgba(16,185,129,0.5)", color:"#80ED99", fontSize:11, fontWeight:800, padding:"3px 10px", borderRadius:20 },
  body: { padding:"18px 22px 20px", flex:1, display:"flex", flexDirection:"column" , minHeight: 0},
  testsLabel: { fontSize:11, fontWeight:700, color:"#64748B", textTransform:"uppercase", letterSpacing:0.5, marginBottom:12 },
  testsList: { flex:1, overflow: "hidden", marginBottom:18 },
  testRow: { display:"flex", alignItems:"flex-start", gap:8, marginBottom:8 },
  dot: { width:7, height:7, borderRadius:"50%", flexShrink:0, marginTop:5 },
  testName: { fontSize:13, color:"#374151", flex:1, lineHeight:1.5 },
  testPrice: { fontSize:12, fontWeight:700, color:"#006D77", flexShrink:0 },
  more: { fontSize:12, color:"#94A3B8", fontStyle:"italic", marginTop:6 },
  footer: { display:"flex",marginTop: "auto", justifyContent:"space-between", alignItems:"center", gap:12, paddingTop:14, borderTop:"1px solid #F1F5F9" },
  footerLeft: { display:"flex", flexDirection:"column", gap:2 },
  totalLabel: { fontSize:11, color:"#94A3B8", fontWeight:600 },
  totalValue: { fontFamily:"'Sora',sans-serif", fontSize:20, fontWeight:900, lineHeight:1 },
  viewBtn: { border:"none", borderRadius:12, padding:"10px 18px", fontSize:13, fontWeight:700, color:"#FFFFFF", cursor:"pointer", whiteSpace:"nowrap", flexShrink:0 },
};

const PM = {
  overlay: { position:"fixed", inset:0, background:"rgba(0,0,0,0.72)", zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center", backdropFilter:"blur(6px)", padding:24 },
  box: { backgroundColor:"#FFFFFF", borderRadius:28, width:"100%", maxWidth:660, maxHeight:"90vh", overflowY:"auto", boxShadow:"0 32px 80px rgba(0,0,0,0.35)" },
  hero: { padding:"36px 32px 28px", position:"relative", overflow:"hidden" },
  hd1: { position:"absolute", top:-50, right:-50, width:200, height:200, borderRadius:"50%", background:"rgba(255,255,255,0.1)" },
  hd2: { position:"absolute", bottom:-30, left:-20, width:130, height:130, borderRadius:"50%", background:"rgba(255,255,255,0.07)" },
  closeBtn: { position:"absolute", top:14, right:14, background:"rgba(255,255,255,0.2)", border:"none", color:"#FFFFFF", width:36, height:36, borderRadius:"50%", cursor:"pointer", fontSize:17, display:"flex", alignItems:"center", justifyContent:"center", zIndex:2, fontWeight:700 },
  tierBadge: { display:"inline-flex", alignItems:"center", gap:7, background:"rgba(255,255,255,0.15)", border:"1px solid rgba(255,255,255,0.25)", padding:"5px 14px", borderRadius:20, fontSize:12, fontWeight:700, color:"#FFFFFF", marginBottom:14, position:"relative", zIndex:1 },
  tierDot: { width:8, height:8, borderRadius:"50%" },
  heroIcon: { fontSize:50, marginBottom:12, position:"relative", zIndex:1 },
  heroTitle: { fontFamily:"'Sora',sans-serif", fontSize:22, fontWeight:800, color:"#FFFFFF", marginBottom:8, position:"relative", zIndex:1 },
  heroSub: { fontSize:14, color:"rgba(255,255,255,0.78)", position:"relative", zIndex:1, lineHeight:1.65, marginBottom:20 },
  priceBlock: { display:"flex", alignItems:"center", gap:20, position:"relative", zIndex:1, flexWrap:"wrap" },
  priceLeft: { display:"flex", flexDirection:"column", gap:3 },
  priceHeroLabel: { fontSize:11, color:"rgba(255,255,255,0.65)", fontWeight:600, textTransform:"uppercase", letterSpacing:0.5 },
  priceHeroValue: { fontFamily:"'Sora',sans-serif", fontSize:32, fontWeight:900, lineHeight:1 },
  strikeMRP: { fontSize:14, color:"rgba(255,255,255,0.5)", textDecoration:"line-through", fontWeight:600 },
  savingsBadge: { display:"flex", flexDirection:"column", alignItems:"center", borderRadius:16, padding:"10px 18px", gap:2 },
  body: { padding:"28px 32px 32px" },
  testsLabel: { fontSize:16, fontWeight:700, color:"#0F172A", marginBottom:16 },
  testsTable: { border:"1px solid #E2E8F0", borderRadius:14, overflow:"hidden", marginBottom:24 },
  colCode: { fontSize:12, fontWeight:700, color:"#64748B" },
  tableRow: { display:"grid", gridTemplateColumns:"1fr", padding:"10px 16px", borderBottom:"1px solid #F1F5F9", alignItems:"center" },
  tableHead: { backgroundColor:"#F8FAFC", borderBottom:"2px solid #E2E8F0" },
  colName: { fontSize:13, color:"#374151", lineHeight:1.5 },
  colPrice: { fontSize:13, textAlign:"right" },
  codeTag: { fontFamily:"monospace", fontSize:11, background:"#EEF4F5", color:"#006D77", padding:"2px 7px", borderRadius:5 },
  totalRow: { backgroundColor:"#F8FAFC", borderTop:"1px solid #E2E8F0", borderBottom:"none" },
  bookBtn: { width:"100%", padding:"16px", border:"none", borderRadius:16, fontSize:16, fontWeight:800, color:"#FFFFFF", cursor:"pointer", marginBottom:12, display:"block", textAlign:"center", letterSpacing:0.3 },
  closeText: { width:"100%", padding:"12px", border:"none", background:"none", fontSize:14, fontWeight:600, color:"#94A3B8", cursor:"pointer", display:"block", textAlign:"center" },
};

const BM = {
  overlay: { position:"fixed", inset:0, background:"rgba(0,0,0,0.72)", zIndex:10000, display:"flex", alignItems:"center", justifyContent:"center", backdropFilter:"blur(6px)", padding:16 },
  box: { backgroundColor:"#FFFFFF", borderRadius:28, width:"100%", maxWidth:620, maxHeight:"92vh", overflowY:"auto", boxShadow:"0 32px 80px rgba(0,0,0,0.35)" },
  hero: { padding:"28px 28px 24px", position:"relative", overflow:"hidden" },
  hd1: { position:"absolute", top:-50, right:-50, width:180, height:180, borderRadius:"50%", background:"rgba(255,255,255,0.1)" },
  hd2: { position:"absolute", bottom:-30, left:-20, width:120, height:120, borderRadius:"50%", background:"rgba(255,255,255,0.07)" },
  closeBtn: { position:"absolute", top:14, right:14, background:"rgba(255,255,255,0.2)", border:"none", color:"#FFFFFF", width:34, height:34, borderRadius:"50%", cursor:"pointer", fontSize:16, display:"flex", alignItems:"center", justifyContent:"center", zIndex:2, fontWeight:700 },
  body: { padding:"24px 28px 28px" },
  sectionTitle: { fontSize:14, fontWeight:800, color:"#0F172A", marginBottom:14, textTransform:"uppercase", letterSpacing:0.5 },
  formGrid: { display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 },
  formGroup: { display:"flex", flexDirection:"column", gap:5 },
  label: { fontSize:12, fontWeight:700, color:"#64748B" },
  input: { border:"1.5px solid #E2E8F0", borderRadius:10, padding:"10px 12px", fontSize:14, color:"#0F172A", fontFamily:"'DM Sans',sans-serif", outline:"none", transition:"border-color 0.2s", background:"#FAFAFA" },
  submitBtn: { width:"100%", padding:"15px", border:"none", borderRadius:14, fontSize:15, fontWeight:800, color:"#FFFFFF", cursor:"pointer", marginBottom:10, display:"block", textAlign:"center" },
  cancelBtn: { width:"100%", padding:"11px", border:"none", background:"none", fontSize:14, fontWeight:600, color:"#94A3B8", cursor:"pointer", display:"block", textAlign:"center" },
  errorBox: { background:"#FEF2F2", border:"1.5px solid #FECACA", borderRadius:12, padding:"12px 16px", fontSize:13, color:"#DC2626", marginBottom:14, fontWeight:600 },
  successGrid: { display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 },
  successItem: { display:"flex", flexDirection:"column", gap:3, background:"#F8FAFC", borderRadius:12, padding:"12px 14px", border:"1px solid #E2E8F0" },
  successLabel: { fontSize:11, fontWeight:700, color:"#94A3B8", textTransform:"uppercase", letterSpacing:0.4 },
  successValue: { fontSize:14, fontWeight:700, color:"#0F172A" },
};

const CC = {
  card: { borderRadius:24, padding:"26px 22px", position:"relative", overflow:"hidden", cursor:"pointer", minHeight:330, transition:"transform 0.3s ease, box-shadow 0.3s ease", display:"flex", flexDirection:"column" },
  d1: { position:"absolute", top:-50, right:-50, width:180, height:180, borderRadius:"50%", background:"rgba(255,255,255,0.09)" },
  d2: { position:"absolute", bottom:-35, left:-25, width:130, height:130, borderRadius:"50%", background:"rgba(255,255,255,0.06)" },
  badge: { display:"inline-block", padding:"5px 13px", borderRadius:10, fontSize:13, fontWeight:900, color:"#1A3A1A", marginBottom:12, position:"relative", zIndex:1 },
  icon: { fontSize:40, marginBottom:10, position:"relative", zIndex:1 },
  title: { fontFamily:"'Sora',sans-serif", fontSize:19, fontWeight:800, color:"#FFFFFF", marginBottom:7, position:"relative", zIndex:1, lineHeight:1.3 },
  subtitle: { fontSize:13, color:"rgba(255,255,255,0.76)", lineHeight:1.65, marginBottom:10, position:"relative", zIndex:1 },
  tests: { flex:1, position:"relative", zIndex:1 },
  testRow: { display:"flex", alignItems:"center", gap:9, marginBottom:9 },
  check: { fontSize:14, fontWeight:800, flexShrink:0 },
  testText: { fontSize:13, color:"rgba(255,255,255,0.9)", fontWeight:500 },
  more: { fontSize:12, color:"rgba(255,255,255,0.52)", marginTop:5 },
  footer: { display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:20, position:"relative", zIndex:1, gap:10 },
  tagline: { fontSize:11, color:"rgba(255,255,255,0.58)", flex:1, lineHeight:1.5 },
  viewBtn: { fontSize:12, fontWeight:700, padding:"6px 13px", border:"1.5px solid", borderRadius:10, whiteSpace:"nowrap" },
};

const SC = {
  card: { backgroundColor:"#FFFFFF", borderRadius:22, overflow:"hidden", transition:"transform 0.3s ease, box-shadow 0.3s ease", display:"flex", flexDirection:"column" },
  topBar: { height:5, backgroundColor:"#006D77", width:"100%" },
  imgWrap: { height:200, overflow:"hidden", position:"relative", backgroundColor:"#E0F2F1" },
  img: { width:"100%", height:"100%", objectFit:"cover" },
  dot: { position:"absolute", top:13, right:13, width:12, height:12, borderRadius:"50%", backgroundColor:"#10B981", boxShadow:"0 0 0 4px rgba(16,185,129,0.25)" },
  comingSoon: { position:"absolute", inset:0, background:"rgba(0,0,0,0.4)", display:"flex", alignItems:"center", justifyContent:"center" },
  comingText: { color:"#FFFFFF", fontWeight:700, fontSize:13, background:"rgba(0,0,0,0.5)", padding:"5px 13px", borderRadius:20 },
  body: { padding:"22px 22px 24px", flex:1, display:"flex", flexDirection:"column" },
  title: { fontFamily:"'Sora',sans-serif", fontSize:15, fontWeight:800, color:"#0F172A", marginBottom:7, lineHeight:1.4 },
  sub: { fontSize:13, color:"#64748B", lineHeight:1.7, marginBottom:12, flex:1 },
  price: { fontSize:16, fontWeight:700, color:"#006D77", marginBottom:15 },
  btn: { display:"inline-block", padding:"12px 18px", borderRadius:13, transition:"opacity 0.2s", marginTop:"auto" },
  btnTxt: { fontSize:13, fontWeight:700, color:"#FFFFFF" },
};

const M = {
  overlay: { position:"fixed", inset:0, background:"rgba(0,0,0,0.65)", zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center", backdropFilter:"blur(6px)", padding:24 },
  box: { backgroundColor:"#FFFFFF", borderRadius:28, width:"100%", maxWidth:580, maxHeight:"88vh", overflowY:"auto", boxShadow:"0 32px 80px rgba(0,0,0,0.3)" },
  hero: { padding:"36px 32px 28px", position:"relative", overflow:"hidden" },
  hd1: { position:"absolute", top:-50, right:-50, width:200, height:200, borderRadius:"50%", background:"rgba(255,255,255,0.1)" },
  hd2: { position:"absolute", bottom:-30, left:-20, width:130, height:130, borderRadius:"50%", background:"rgba(255,255,255,0.07)" },
  closeBtn: { position:"absolute", top:14, right:14, background:"rgba(255,255,255,0.2)", border:"none", color:"#FFFFFF", width:36, height:36, borderRadius:"50%", cursor:"pointer", fontSize:17, display:"flex", alignItems:"center", justifyContent:"center", zIndex:2, fontWeight:700 },
  badge: { display:"inline-block", padding:"5px 14px", borderRadius:10, fontSize:13, fontWeight:900, color:"#1A3A1A", marginBottom:14, position:"relative", zIndex:1 },
  heroIcon: { fontSize:46, marginBottom:12, position:"relative", zIndex:1 },
  heroTitle: { fontFamily:"'Sora',sans-serif", fontSize:24, fontWeight:800, color:"#FFFFFF", marginBottom:8, position:"relative", zIndex:1 },
  heroSub: { fontSize:15, color:"rgba(255,255,255,0.8)", position:"relative", zIndex:1, lineHeight:1.65 },
  body: { padding:"28px 32px 32px" },
  sectionLabel: { fontSize:16, fontWeight:700, color:"#0F172A", marginBottom:18 },
  testGrid: { display:"grid", gridTemplateColumns:"1fr 1fr", gap:10, marginBottom:24 },
  testChip: { display:"flex", alignItems:"center", gap:10, background:"#F8FAFC", borderRadius:12, padding:"11px 14px", border:"1px solid #E2E8F0" },
  chipDot: { width:8, height:8, borderRadius:"50%", flexShrink:0 },
  chipText: { fontSize:13, color:"#374151", fontWeight:500, lineHeight:1.4 },
  noteBox: { background:"#F8FAFC", borderRadius:16, padding:"18px 20px", border:"1px solid #E2E8F0", marginBottom:24 },
  noteText: { fontSize:14, color:"#64748B", marginBottom:8, lineHeight:1.65 },
  tagline: { fontSize:15, fontWeight:600, color:"#0F172A" },
  callBtn: { width:"100%", padding:"16px", border:"none", borderRadius:16, fontSize:16, fontWeight:800, color:"#FFFFFF", cursor:"pointer", marginBottom:12, display:"block", textAlign:"center" },
  closeText: { width:"100%", padding:"12px", border:"none", background:"none", fontSize:14, fontWeight:600, color:"#94A3B8", cursor:"pointer", display:"block", textAlign:"center" },
};